global.version = "1.0.0";
global.bank = [
  {
    icon: "BNP.png",
    value: "BNP",
    label: "BNP Paribas Bangkok Branch",
    name_th: "",
  },
  {
    icon: "MHBC.png",
    value: "MHBC",
    label: "Mizuho Corporate Bank",
    name_th: "",
  },
  {
    icon: "DEUTSHE.png",
    value: "DEUTSHE",
    label: "Deutsche Bank AG.",
    name_th: "",
  },
  {
    icon: "CGC.png",
    value: "CGC",
    label: "Credit Agricole Corporate and Investment Bank",
    name_th: "",
  },
  {
    icon: "BA.png",
    value: "BA",
    label: "Bank of America National Association",
    name_th: "",
  },
  {
    icon: "MEGAICBC.png",
    value: "MEGAICBC",
    label: "Mega International Commercial Bank",
    name_th: "",
  },
  {
    icon: "SCBT.png",
    value: "SCBT",
    label: "Standard Chartered Bank",
    name_th: "",
  },
  {
    icon: "SMBC.png",
    value: "SMBC",
    label: "Sumitomo Mitsui Banking Corporation",
    name_th: "",
  },
  { icon: "CITI.png", value: "CITI", label: "CITI Bank N.A.", name_th: "" },
  { icon: "TMB.png", value: "TMB", label: "TMB Bank", name_th: "" },
  {
    icon: "RBS.png",
    value: "RBS",
    label: "The Royal Bank of Scotland N.V.",
    name_th: "",
  },
  { icon: "BOT.png", value: "BOT", label: "Bank of Thailand", name_th: "" },
  {
    icon: "CIMB.png",
    value: "CIMB",
    label: "CIMB Thai",
    name_th: "ธนาคารซีไอเอ็มบีไทย",
  },
  {
    icon: "LHBANK.png",
    value: "LHBANK",
    label: "Land and Houses Bank",
    name_th: "ธนาคารแลนด์แอนด์เฮ้าส์",
  },
  {
    icon: "TCRB.png",
    value: "TCRB",
    label: "The Thai Credit Retail Bank",
    name_th: "ธนาคารไทยเครดิตเพื่อรายย่อย",
  },
  {
    icon: "KKP.png",
    value: "KKP",
    label: "Kiatnakin Bank",
    name_th: "ธนาคารเกียรตินาคิน",
  },
  {
    icon: "TISCO.png",
    value: "TISCO",
    label: "Tisco Bank",
    name_th: "ธนาคารทิสโก้",
  },
  {
    icon: "IBANK.png",
    value: "IBANK",
    label: "Islamic Bank of Thailand",
    name_th: "ธนาคารอิสลามแห่งประเทศไทย",
  },
  {
    icon: "HSBC.png",
    value: "HSBC",
    label: "Hong Kong & Shanghai Corporation",
    name_th: "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น",
  },
  {
    icon: "UOB.png",
    value: "UOB",
    label: "United Overseas Bank",
    name_th: "ธนาคารยูโอบี (ไทย)",
  },
  {
    icon: "ICBC.png",
    value: "ICBC",
    label: "Industrial and Commercial Bank of China Limited",
    name_th: "ธนาคารพาณิชย์อุตสาหกรรมแห่งประเทศจีน",
  },
  {
    icon: "BAAC.png",
    value: "BAAC",
    label: "Bank for Agriculture and Agricultural Cooperatives",
    name_th: "ธ.ก.ส.",
  },
  {
    icon: "GHB.png",
    value: "GHB",
    label: "Government Housing Bank",
    name_th: "ธนาคารอาคารสงเคราะห์",
  },
  {
    icon: "GSB.png",
    value: "GSB",
    label: "Government Savings Bank",
    name_th: "ธนาคารออมสิน",
  },
  {
    icon: "BAY.png",
    value: "BAY",
    label: "Bank of Ayudhya",
    name_th: "ธนาคารกรุงศรีอยุธยา",
  },
  {
    icon: "KTB.png",
    value: "KTB",
    label: "Krung Thai Bank",
    name_th: "ธนาคารกรุงไทย",
  },
  {
    icon: "BBL.png",
    value: "BBL",
    label: "Bangkok Bank",
    name_th: "ธนาคารกรุงเทพ",
  },
  {
    icon: "TTB.png",
    value: "TTB",
    label: "TTB Thanachart Bank",
    name_th: "ธนาคารทหารไทยธนชาต",
  },
  {
    icon: "KBANK.png",
    value: "KBANK",
    label: "Kasikorn Bank",
    name_th: "ธนาคารกสิกรไทย",
  },
  {
    icon: "SCB.png",
    value: "SCB",
    label: "Siam Commercial Bank",
    name_th: "ธนาคารไทยพาณิชย์",
  },
];
global.payment = [
  {name:"Promptpay QR", image: (require(`../assets/images/mobile/image-1.jpg`)), fee: 0.02},
  {name:"Coin", image: (require(`../assets/images/mobile/image-6.png`)), fee: 0},
  {name:"Mobile banking", image: (require(`../assets/images/mobile/image-2.jpg`)), fee: 0.03},
  {name:"Line Pay", image: (require(`../assets/images/mobile/image-3.jpg`)), fee: 0.12},
  {name:"True Money", image: (require(`../assets/images/mobile/image-4.jpg`)), fee: 0.12},
  {name:"ShopeePay", image: (require(`../assets/images/mobile/image-5.jpg`)), fee: 0.05},
];
global.game = [
  {
    "name": "Free Fire",
    "image": "https://itemmania.s3.amazonaws.com/game/5HMvENDOSCmG9HxEB3S4Er4iOuLCd1YM8yX4lNPm.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/716",
    "package": [
      {
        "name": "แพ็กรายสัปดาห์",
        "old_price": "69.0",
        "new_price": "65.5"
      },
      {
        "name": "แพ็กรายเดือน",
        "old_price": "299.0",
        "new_price": "288.5"
      },
      {
        "name": "แพ็กรายสัปดาห์มินิ",
        "old_price": "35.0",
        "new_price": "33.2"
      },
      {
        "name": "BP Card (ไม่ใช่แพ็กเพชร)",
        "old_price": "90.0",
        "new_price": "86.8"
      },
      {
        "name": "33 เพชร",
        "old_price": "",
        "new_price": "10.0"
      },
      {
        "name": "68 เพชร",
        "old_price": "",
        "new_price": "20.0"
      },
      {
        "name": "172 เพชร",
        "old_price": "50.0",
        "new_price": "48.1"
      },
      {
        "name": "310 เพชร",
        "old_price": "90.0",
        "new_price": "86.6"
      },
      {
        "name": "517 เพชร",
        "old_price": "150.0",
        "new_price": "144.4"
      },
      {
        "name": "1,052 เพชร",
        "old_price": "300.0",
        "new_price": "288.9"
      },
      {
        "name": "1,801 เพชร",
        "old_price": "500.0",
        "new_price": "479.0"
      },
      {
        "name": "3,698 เพชร",
        "old_price": "1,000.0",
        "new_price": "955.0"
      },
      {
        "name": "7,396 เพชร",
        "old_price": "2,000.0",
        "new_price": "1,910.0"
      },
      {
        "name": "11,094 เพชร",
        "old_price": "3,000.0",
        "new_price": "2,865.0"
      },
      {
        "name": "14,792 เพชร",
        "old_price": "4,000.0",
        "new_price": "3,820.0"
      },
      {
        "name": "18,490 เพชร",
        "old_price": "5,000.0",
        "new_price": "4,775.0"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟไทยเท่านั้น!**1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "RoV",
    "image": "https://itemmania.s3.amazonaws.com/game/r3KTm4y38plwLSWav6ulpej6sq3WVO4QRQKLmw3X.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/690",
    "package": [
      {
        "name": "7,440 (แพ็กจัดหนัก โคนันxจอมโจรคิด)",
        "old_price": "6,000.0",
        "new_price": "5,730.0"
      },
      {
        "name": "2,045 (เอาแค่สกินจอมโจรคิด *เคยสุ่มโคนันแล้ว)",
        "old_price": "1,650.0",
        "new_price": "1,579.0"
      },
      {
        "name": "2,700 (ยอร์นxโคนัน *สำหรับเอาแค่สกิน)",
        "old_price": "2,180.0",
        "new_price": "2,081.9"
      },
      {
        "name": "4,015  (ยอร์นxโคนัน *เหมาทุกอย่าง)",
        "old_price": "3,240.0",
        "new_price": "3,094.2"
      },
      {
        "name": "555 (VP ขั้นสูง)",
        "old_price": "450.0",
        "new_price": "434.2"
      },
      {
        "name": "306 (VP Lv.1)",
        "old_price": "250.0",
        "new_price": "241.2"
      },
      {
        "name": "405 (VP ขั้นสูง ครั้งแรก)",
        "old_price": "330.0",
        "new_price": "318.4"
      },
      {
        "name": "209 (VP Lv.1 ครั้งแรก)",
        "old_price": "170.0",
        "new_price": "164.3"
      },
      {
        "name": "11",
        "old_price": "10.0",
        "new_price": "9.9"
      },
      {
        "name": "24",
        "old_price": "20.0",
        "new_price": "19.6"
      },
      {
        "name": "60",
        "old_price": "50.0",
        "new_price": "48.3"
      },
      {
        "name": "72",
        "old_price": "60.0",
        "new_price": "58.0"
      },
      {
        "name": "84",
        "old_price": "70.0",
        "new_price": "67.6"
      },
      {
        "name": "110",
        "old_price": "90.0",
        "new_price": "87.0"
      },
      {
        "name": "121",
        "old_price": "100.0",
        "new_price": "96.7"
      },
      {
        "name": "185",
        "old_price": "150.0",
        "new_price": "145.0"
      },
      {
        "name": "220",
        "old_price": "180.0",
        "new_price": "174.0"
      },
      {
        "name": "295",
        "old_price": "240.0",
        "new_price": "232.0"
      },
      {
        "name": "370",
        "old_price": "300.0",
        "new_price": "289.5"
      },
      {
        "name": "491",
        "old_price": "400.0",
        "new_price": "386.0"
      },
      {
        "name": "504",
        "old_price": "410.0",
        "new_price": "395.6"
      },
      {
        "name": "620",
        "old_price": "500.0",
        "new_price": "482.5"
      },
      {
        "name": "730",
        "old_price": "590.0",
        "new_price": "566.4"
      },
      {
        "name": "805",
        "old_price": "650.0",
        "new_price": "624.0"
      },
      {
        "name": "915",
        "old_price": "740.0",
        "new_price": "710.4"
      },
      {
        "name": "1,100",
        "old_price": "890.0",
        "new_price": "854.4"
      },
      {
        "name": "1,240",
        "old_price": "1,000.0",
        "new_price": "957.0"
      },
      {
        "name": "1,535",
        "old_price": "1,240.0",
        "new_price": "1,186.6"
      },
      {
        "name": "1,610",
        "old_price": "1,300.0",
        "new_price": "1,244.1"
      },
      {
        "name": "1,860",
        "old_price": "1,500.0",
        "new_price": "1,435.5"
      },
      {
        "name": "2,230",
        "old_price": "1,800.0",
        "new_price": "1,722.6"
      },
      {
        "name": "2,540",
        "old_price": "2,050.0",
        "new_price": "1,957.7"
      },
      {
        "name": "2,850",
        "old_price": "2,300.0",
        "new_price": "2,196.5"
      },
      {
        "name": "3,100",
        "old_price": "2,500.0",
        "new_price": "2,387.5"
      },
      {
        "name": "3,470",
        "old_price": "2,800.0",
        "new_price": "2,674.0"
      },
      {
        "name": "3,720",
        "old_price": "3,000.0",
        "new_price": "2,865.0"
      },
      {
        "name": "4,340",
        "old_price": "3,500.0",
        "new_price": "3,342.5"
      },
      {
        "name": "4,710",
        "old_price": "3,800.0",
        "new_price": "3,629.0"
      },
      {
        "name": "4,960",
        "old_price": "4,000.0",
        "new_price": "3,820.0"
      },
      {
        "name": "5,145",
        "old_price": "4,150.0",
        "new_price": "3,963.2"
      },
      {
        "name": "5,580",
        "old_price": "4,500.0",
        "new_price": "4,297.5"
      },
      {
        "name": "6,200",
        "old_price": "5,000.0",
        "new_price": "4,775.0"
      },
      {
        "name": "6,820",
        "old_price": "5,500.0",
        "new_price": "5,252.5"
      },
      {
        "name": "8,060",
        "old_price": "6,500.0",
        "new_price": "6,207.5"
      },
      {
        "name": "9,300",
        "old_price": "7,500.0",
        "new_price": "7,162.5"
      },
      {
        "name": "12,400",
        "old_price": "10,000.0",
        "new_price": "9,550.0"
      }
    ],
    "cont": "\n                1. กรอก OpenID   -ดูได้โดยกดที่ โปรไฟล์มุมซ้ายบน > ตั้งค่า > OpenID > กดคัดลอก 2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้หมายเหตุ - ตรวจสอบ OpenID ให้ถูกต้อง **OpenID ไม่ใช่ Full ID**- หากกรอก OpenID มาผิดแล้วเติมไม่เข้า จะไม่คืนเงินทุกกรณี\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "VALORANT",
    "image": "https://itemmania.s3.amazonaws.com/game/FvrumgyXFxpJi9irDwqrCP0eJiIy3jKBUUDImNHY.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/590",
    "package": [
      {
        "name": "475",
        "old_price": "130.0",
        "new_price": "122.3"
      },
      {
        "name": "1,000",
        "old_price": "260.0",
        "new_price": "244.6"
      },
      {
        "name": "2,050",
        "old_price": "520.0",
        "new_price": "489.3"
      },
      {
        "name": "2,525",
        "old_price": "650.0",
        "new_price": "611.6"
      },
      {
        "name": "3,050",
        "old_price": "780.0",
        "new_price": "733.9"
      },
      {
        "name": "3,650",
        "old_price": "920.0",
        "new_price": "865.7"
      },
      {
        "name": "4,650",
        "old_price": "1,180.0",
        "new_price": "1,110.3"
      },
      {
        "name": "5,350",
        "old_price": "1,320.0",
        "new_price": "1,242.1"
      },
      {
        "name": "5,825",
        "old_price": "1,450.0",
        "new_price": "1,364.4"
      },
      {
        "name": "7,150",
        "old_price": "1,820.0",
        "new_price": "1,712.6"
      },
      {
        "name": "7,400",
        "old_price": "1,840.0",
        "new_price": "1,731.4"
      },
      {
        "name": "8,400",
        "old_price": "2,100.0",
        "new_price": "1,976.1"
      },
      {
        "name": "9,000",
        "old_price": "2,240.0",
        "new_price": "2,107.8"
      },
      {
        "name": "11,000",
        "old_price": "2,640.0",
        "new_price": "2,484.2"
      },
      {
        "name": "12,000",
        "old_price": "2,900.0",
        "new_price": "2,728.9"
      },
      {
        "name": "13,050",
        "old_price": "3,160.0",
        "new_price": "2,973.5"
      },
      {
        "name": "14,650",
        "old_price": "3,560.0",
        "new_price": "3,349.9"
      },
      {
        "name": "16,350",
        "old_price": "3,960.0",
        "new_price": "3,726.3"
      },
      {
        "name": "22,000",
        "old_price": "5,280.0",
        "new_price": "4,968.4"
      }
    ],
    "cont": "\n                1. กรอก Riot ID + Tag  -ดูได้โดยกดที่ โปรไฟล์และเอาเมาส์ชี้ไปที่ชื่อ จะแสดง Riot ID + Tag2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "League of Legends",
    "image": "https://itemmania.s3.amazonaws.com/game/rsNFIIaxoQxAB9MdlR63aK4lQe1DBpm1qwR57rDQ.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2032",
    "package": [
      {
        "name": "575",
        "old_price": "130.0",
        "new_price": "122.3"
      },
      {
        "name": "1,380",
        "old_price": "290.0",
        "new_price": "272.8"
      },
      {
        "name": "1,955",
        "old_price": "420.0",
        "new_price": "395.2"
      },
      {
        "name": "2,800",
        "old_price": "560.0",
        "new_price": "526.9"
      },
      {
        "name": "3,375",
        "old_price": "690.0",
        "new_price": "649.2"
      },
      {
        "name": "3,950 (Bundle Premium)",
        "old_price": "820.0",
        "new_price": "771.6"
      },
      {
        "name": "4,500",
        "old_price": "890.0",
        "new_price": "837.4"
      },
      {
        "name": "5,075",
        "old_price": "1,020.0",
        "new_price": "959.8"
      },
      {
        "name": "5,880",
        "old_price": "1,180.0",
        "new_price": "1,110.3"
      },
      {
        "name": "6,500",
        "old_price": "1,250.0",
        "new_price": "1,176.2"
      },
      {
        "name": "7,075",
        "old_price": "1,380.0",
        "new_price": "1,298.5"
      },
      {
        "name": "7,880",
        "old_price": "1,540.0",
        "new_price": "1,449.1"
      },
      {
        "name": "9,300",
        "old_price": "1,810.0",
        "new_price": "1,703.2"
      },
      {
        "name": "11,000",
        "old_price": "2,140.0",
        "new_price": "2,013.7"
      },
      {
        "name": "13,500",
        "old_price": "2,550.0",
        "new_price": "2,399.5"
      },
      {
        "name": "14,880",
        "old_price": "2,840.0",
        "new_price": "2,672.4"
      },
      {
        "name": "16,300",
        "old_price": "3,110.0",
        "new_price": "2,926.5"
      },
      {
        "name": "18,000",
        "old_price": "3,440.0",
        "new_price": "3,237.0"
      },
      {
        "name": "20,000",
        "old_price": "3,800.0",
        "new_price": "3,575.8"
      },
      {
        "name": "27,000",
        "old_price": "5,100.0",
        "new_price": "4,799.1"
      },
      {
        "name": "33,500",
        "old_price": "6,350.0",
        "new_price": "5,975.3"
      },
      {
        "name": "59,075",
        "old_price": "11,220.0",
        "new_price": "10,558.0"
      }
    ],
    "cont": "\n                * เติมได้เฉพาะเซิร์ฟไทย *1. กรอก Riot ID + Tag  -ดูได้โดยกดที่ โปรไฟล์และเอาเมาส์ชี้ไปที่ชื่อ จะแสดง Riot ID + Tag2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "League of Legends: Wild Rift (TH)",
    "image": "https://itemmania.s3.amazonaws.com/game/6mmVQzkceyD80SWNxeyJpnkqrD1IL7nOFXEIEVn0.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2030",
    "package": [
      {
        "name": "425",
        "old_price": "150.0",
        "new_price": "141.1"
      },
      {
        "name": "1,000",
        "old_price": "340.0",
        "new_price": "319.9"
      },
      {
        "name": "1,850",
        "old_price": "600.0",
        "new_price": "564.6"
      },
      {
        "name": "3,275",
        "old_price": "1,050.0",
        "new_price": "988.0"
      },
      {
        "name": "4,800",
        "old_price": "1,500.0",
        "new_price": "1,411.5"
      },
      {
        "name": "10,000",
        "old_price": "3,000.0",
        "new_price": "2,823.0"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟไทยเท่านั้น!**1. กรอก Riot ID + Tag  -ดูได้โดยกดที่ โปรไฟล์และเอาเมาส์ชี้ไปที่ชื่อ จะแสดง Riot ID + Tag2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Blood Strike",
    "image": "https://itemmania.s3.amazonaws.com/game/rgS5rvCZ4nOLCGJUXhOLMrkltMoMol82Kq6kURhH.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2258",
    "package": [
      {
        "name": "Strike Pass",
        "old_price": "159.0",
        "new_price": "101.6"
      },
      {
        "name": "Strike Pass (Elite+)",
        "old_price": "359.0",
        "new_price": "225.8"
      },
      {
        "name": "100+5",
        "old_price": "39.0",
        "new_price": "27.5"
      },
      {
        "name": "300+20",
        "old_price": "119.0",
        "new_price": "76.5"
      },
      {
        "name": "500+40",
        "old_price": "199.0",
        "new_price": "126.3"
      },
      {
        "name": "1,000+100",
        "old_price": "399.0",
        "new_price": "252.9"
      },
      {
        "name": "2,000+260",
        "old_price": "799.0",
        "new_price": "498.5"
      },
      {
        "name": "5,000+800",
        "old_price": "1,990.0",
        "new_price": "1,223.8"
      },
      {
        "name": "10,000+1,600",
        "old_price": "3,980.0",
        "new_price": "2,447.7"
      },
      {
        "name": "15,000+2,400",
        "old_price": "5,970.0",
        "new_price": "3,671.5"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Arena Breakout",
    "image": "https://itemmania.s3.amazonaws.com/game/A181pBH8ihcgTHiZWrYQGSaVio9z06t3SiVtx3tR.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2196",
    "package": [
      {
        "name": "Battle Pass พรีเมี่ยม",
        "old_price": "559.0",
        "new_price": "365.5"
      },
      {
        "name": "Battle Pass ธรรมดา",
        "old_price": "189.0",
        "new_price": "133.8"
      },
      {
        "name": "บันเดิลมือใหม่ [VIP + เซฟ4ช่อง 3 วัน]",
        "old_price": "39.0",
        "new_price": "27.8"
      },
      {
        "name": "Bulletproof Case (30วัน) [เซฟ 4 ช่อง]",
        "old_price": "110.0",
        "new_price": "81.2"
      },
      {
        "name": "Composite Case (30วัน) [เซฟ 6 ช่อง]",
        "old_price": "335.0",
        "new_price": "226.7"
      },
      {
        "name": "66",
        "old_price": "39.0",
        "new_price": "31.7"
      },
      {
        "name": "335",
        "old_price": "189.0",
        "new_price": "146.0"
      },
      {
        "name": "675",
        "old_price": "375.0",
        "new_price": "311.2"
      },
      {
        "name": "1,690",
        "old_price": "939.0",
        "new_price": "723.9"
      },
      {
        "name": "3,400",
        "old_price": "1,870.0",
        "new_price": "1,322.0"
      },
      {
        "name": "6,820",
        "old_price": "3,750.0",
        "new_price": "2,508.7"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "PUBG M (TH)",
    "image": "https://itemmania.s3.amazonaws.com/game/LhxSzizAiWpYOJ22wnxQCV8CYgLRLGr1MXuzPH9C.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2254",
    "package": [
      {
        "name": "60",
        "old_price": "33.0",
        "new_price": "31.6"
      },
      {
        "name": "325 (300+25)",
        "old_price": "165.0",
        "new_price": "148.6"
      },
      {
        "name": "385",
        "old_price": "198.0",
        "new_price": "178.3"
      },
      {
        "name": "660 (600+60)",
        "old_price": "330.0",
        "new_price": "295.6"
      },
      {
        "name": "720",
        "old_price": "363.0",
        "new_price": "325.2"
      },
      {
        "name": "1,320",
        "old_price": "660.0",
        "new_price": "591.3"
      },
      {
        "name": "1,800 (1,500+300)",
        "old_price": "825.0",
        "new_price": "735.0"
      },
      {
        "name": "1,920",
        "old_price": "891.0",
        "new_price": "793.8"
      },
      {
        "name": "2,125",
        "old_price": "990.0",
        "new_price": "882.0"
      },
      {
        "name": "2,460",
        "old_price": "1,155.0",
        "new_price": "1,029.1"
      },
      {
        "name": "3,850 (3,000+850)",
        "old_price": "1,650.0",
        "new_price": "1,438.8"
      },
      {
        "name": "4,510",
        "old_price": "1,980.0",
        "new_price": "1,726.5"
      },
      {
        "name": "5,650",
        "old_price": "2,475.0",
        "new_price": "2,158.2"
      },
      {
        "name": "8,100 (6,000+2100)",
        "old_price": "3,300.0",
        "new_price": "2,841.3"
      },
      {
        "name": "16,200 (8,100x2)",
        "old_price": "6,600.0",
        "new_price": "5,682.6"
      },
      {
        "name": "24,300 (8,100x3)",
        "old_price": "9,900.0",
        "new_price": "8,523.9"
      },
      {
        "name": "32,400",
        "old_price": "13,200.0",
        "new_price": "11,365.2"
      },
      {
        "name": "Prime 1 เดือน",
        "old_price": "35.0",
        "new_price": "32.8"
      },
      {
        "name": "Prime 3 เดือน",
        "old_price": "105.0",
        "new_price": "93.0"
      },
      {
        "name": "Prime 6 เดือน",
        "old_price": "210.0",
        "new_price": "181.2"
      },
      {
        "name": "Prime 12 เดือน",
        "old_price": "420.0",
        "new_price": "371.2"
      },
      {
        "name": "Prime Plus 1 เดือน",
        "old_price": "329.0",
        "new_price": "308.9"
      },
      {
        "name": "Prime Plus 3 เดือน",
        "old_price": "987.0",
        "new_price": "869.5"
      },
      {
        "name": "Prime Plus 6 เดือน",
        "old_price": "1,974.0",
        "new_price": "1,733.1"
      },
      {
        "name": "Prime Plus 12 เดือน",
        "old_price": "3,948.0",
        "new_price": "3,426.8"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟไทยเท่านั้น!**1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "PUBG M (Global)",
    "image": "https://itemmania.s3.amazonaws.com/game/8fh9qGJV1xFAY4hlxXP9hkU6H0MUERrI89uPVODq.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2278",
    "package": [
      {
        "name": "60",
        "old_price": "36.0",
        "new_price": "31.4"
      },
      {
        "name": "325",
        "old_price": "180.0",
        "new_price": "147.6"
      },
      {
        "name": "660 (ไอดี ตปท)",
        "old_price": "360.0",
        "new_price": "295.2"
      },
      {
        "name": "1,800 (ไอดี ตปท)",
        "old_price": "900.0",
        "new_price": "738.0"
      },
      {
        "name": "3,850 (ไอดี ตปท)",
        "old_price": "1,800.0",
        "new_price": "1,447.2"
      },
      {
        "name": "8,100 (ไอดี ตปท)",
        "old_price": "3,600.0",
        "new_price": "2,876.4"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟไทยเท่านั้น!**1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Crystal of Atlan",
    "image": "https://itemmania.s3.amazonaws.com/game/SoxSdY1vDY5TRvl6CJ55VUJVyqrI61qYdP1qsIAf.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2372",
    "package": [
      {
        "name": "60 Vouchers",
        "old_price": "35.0",
        "new_price": "32.3"
      },
      {
        "name": "300 Vouchers",
        "old_price": "175.0",
        "new_price": "151.3"
      },
      {
        "name": "980 Vouchers",
        "old_price": "520.0",
        "new_price": "449.8"
      },
      {
        "name": "1,980 Vouchers",
        "old_price": "1,040.0",
        "new_price": "855.9"
      },
      {
        "name": "3,280 Vouchers",
        "old_price": "1,730.0",
        "new_price": "1,408.2"
      },
      {
        "name": "6,480 Vouchers",
        "old_price": "3,490.0",
        "new_price": "2,805.9"
      },
      {
        "name": "19,800 Vouchers",
        "old_price": "10,470.0",
        "new_price": "8,470.2"
      },
      {
        "name": "60 Opals",
        "old_price": "35.0",
        "new_price": "32.3"
      },
      {
        "name": "300 Opals",
        "old_price": "175.0",
        "new_price": "151.3"
      },
      {
        "name": "980 Opals",
        "old_price": "520.0",
        "new_price": "449.8"
      },
      {
        "name": "1,980 Opals",
        "old_price": "1,040.0",
        "new_price": "855.9"
      },
      {
        "name": "3,280 Opals",
        "old_price": "1,730.0",
        "new_price": "1,408.2"
      },
      {
        "name": "6,480 Opals",
        "old_price": "3,490.0",
        "new_price": "2,805.9"
      },
      {
        "name": "19,800 Opals",
        "old_price": "10,470.0",
        "new_price": "8,470.2"
      },
      {
        "name": "Phantasium Pass 15 Day",
        "old_price": "90.0",
        "new_price": "82.4"
      },
      {
        "name": "Phantasium Pass 30 Day",
        "old_price": "155.0",
        "new_price": "146.0"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Lineage 2 Mobile",
    "image": "https://itemmania.s3.amazonaws.com/game/wQ3SId0c493KkJ0JUPfLj2pIxlN0BhUAgypcNC90.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2370",
    "package": [
      {
        "name": "40",
        "old_price": "28.0",
        "new_price": "24.5"
      },
      {
        "name": "100",
        "old_price": "70.0",
        "new_price": "56.9"
      },
      {
        "name": "120",
        "old_price": "84.0",
        "new_price": "66.3"
      },
      {
        "name": "200",
        "old_price": "140.0",
        "new_price": "110.6"
      },
      {
        "name": "400",
        "old_price": "280.0",
        "new_price": "217.2"
      },
      {
        "name": "1,000",
        "old_price": "700.0",
        "new_price": "543.2"
      },
      {
        "name": "1,200",
        "old_price": "840.0",
        "new_price": "640.9"
      },
      {
        "name": "2,000",
        "old_price": "1,400.0",
        "new_price": "1,068.2"
      },
      {
        "name": "4,000",
        "old_price": "2,800.0",
        "new_price": "2,130.8"
      },
      {
        "name": "10,000",
        "old_price": "7,000.0",
        "new_price": "5,327.0"
      },
      {
        "name": "20,000",
        "old_price": "14,000.0",
        "new_price": "10,626.0"
      },
      {
        "name": "40,000 (20,000 x 2)",
        "old_price": "28,000.0",
        "new_price": "21,252.0"
      },
      {
        "name": "60,000 (20,000 x 3)",
        "old_price": "42,000.0",
        "new_price": "31,878.0"
      },
      {
        "name": "Daily Package 1",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Daily Package 2",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Daily Package 3",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Weekly Top-Up Class Benefits 1",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Weekly Top-Up Class Benefits 2",
        "old_price": "42.0",
        "new_price": "33.4"
      },
      {
        "name": "Weekly Top-Up Class Benefits 3",
        "old_price": "70.0",
        "new_price": "56.3"
      },
      {
        "name": "Weekly Top-Up Agathion Benefits 1",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Weekly Top-Up Agathion Benefits 2",
        "old_price": "42.0",
        "new_price": "33.4"
      },
      {
        "name": "Weekly Top-Up Agathion Benefits 3",
        "old_price": "70.0",
        "new_price": "56.3"
      },
      {
        "name": "New Adventure Package",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Welcome Class Key",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Welcome Class Agathion Key",
        "old_price": "140.0",
        "new_price": "108.9"
      },
      {
        "name": "อัญเชิญคลาสหรูหรา x 1",
        "old_price": "70.0",
        "new_price": "54.9"
      },
      {
        "name": "(เติม 5 แพ็ก) อัญเชิญคลาสหรูหรา x 1",
        "old_price": "350.0",
        "new_price": "276.5"
      },
      {
        "name": "อัญเชิญคลาสหรูหรา x 11",
        "old_price": "700.0",
        "new_price": "553.7"
      },
      {
        "name": "อัญเชิญอากาธิออนหรูหรา x 1",
        "old_price": "70.0",
        "new_price": "54.9"
      },
      {
        "name": "(เติม 5 แพ็ก) อัญเชิญอากาธิออนหรูหรา x 1",
        "old_price": "350.0",
        "new_price": "276.5"
      },
      {
        "name": "อัญเชิญอากาธิออนหรูหรา x 11",
        "old_price": "770.0",
        "new_price": "553.6"
      },
      {
        "name": "(เติม 5 แพ็ก) อัญเชิญอากาธิออนหรูหรา x 11",
        "old_price": "3,850.0",
        "new_price": "2,768.1"
      },
      {
        "name": "Adena Super Benefit",
        "old_price": "26.0",
        "new_price": "24.4"
      },
      {
        "name": "Class Benefit 1",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Class Benefit 2",
        "old_price": "70.0",
        "new_price": "54.9"
      },
      {
        "name": "Class Benefit 3",
        "old_price": "140.0",
        "new_price": "108.9"
      },
      {
        "name": "Agathion Benefit 1",
        "old_price": "28.0",
        "new_price": "22.6"
      },
      {
        "name": "Agathion Benefit 2",
        "old_price": "70.0",
        "new_price": "54.9"
      },
      {
        "name": "Agathion Benefit 3",
        "old_price": "140.0",
        "new_price": "108.9"
      },
      {
        "name": "Buy 1 get 1 summon x 1",
        "old_price": "70.0",
        "new_price": "57.1"
      },
      {
        "name": "Buy 1 get 1 summon x 11",
        "old_price": "700.0",
        "new_price": "553.7"
      },
      {
        "name": "Growth Support Class Package",
        "old_price": "1,400.0",
        "new_price": "1,080.8"
      },
      {
        "name": "Growth Support Agathion Package",
        "old_price": "1,400.0",
        "new_price": "1,080.8"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Call of Duty Mobile",
    "image": "https://itemmania.s3.amazonaws.com/game/TtNnBibLmOQ1xMKID2mewActOrQt2gaYzJkdQBq9.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2368",
    "package": [
      {
        "name": "44+4 Cp",
        "old_price": "",
        "new_price": "22.0"
      },
      {
        "name": "108+18 Cp",
        "old_price": "50.0",
        "new_price": "48.5"
      },
      {
        "name": "194+33 Cp",
        "old_price": "90.0",
        "new_price": "87.3"
      },
      {
        "name": "237+15 Cp",
        "old_price": "100.0",
        "new_price": "97.0"
      },
      {
        "name": "324+54 Cp",
        "old_price": "150.0",
        "new_price": "145.0"
      },
      {
        "name": "648+144 Cp",
        "old_price": "300.0",
        "new_price": "289.2"
      },
      {
        "name": "1,080+360 Cp",
        "old_price": "500.0",
        "new_price": "480.0"
      },
      {
        "name": "2,160+840 Cp",
        "old_price": "1,000.0",
        "new_price": "960.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ Player ID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Delta Force (การีนา) Mobile และ PC",
    "image": "https://itemmania.s3.amazonaws.com/game/MCJZVakWiwjzhQkaZEpMpXPIlhnoOXTyjWhjVlwa.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2358",
    "package": [
      {
        "name": "18+1 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "",
        "new_price": "10.0"
      },
      {
        "name": "30+2 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "",
        "new_price": "17.0"
      },
      {
        "name": "60+3 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "34.0",
        "new_price": "33.3"
      },
      {
        "name": "300+36 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "175.0",
        "new_price": "169.9"
      },
      {
        "name": "420+62 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "245.0",
        "new_price": "237.8"
      },
      {
        "name": "680+105 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "345.0",
        "new_price": "333.2"
      },
      {
        "name": "1,280+264 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "690.0",
        "new_price": "666.5"
      },
      {
        "name": "1,680+385 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "865.0",
        "new_price": "832.9"
      },
      {
        "name": "3,280+834 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "1,730.0",
        "new_price": "1,665.9"
      },
      {
        "name": "6,480+1,944 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "3,460.0",
        "new_price": "3,328.5"
      },
      {
        "name": "12,960+3,888 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "6,920.0",
        "new_price": "6,636.2"
      },
      {
        "name": "19,440+5,832 (ไอดีต้องไม่ผูกการีนา)",
        "old_price": "10,400.0",
        "new_price": "9,963.2"
      },
      {
        "name": "Silent Sentinel Supplies",
        "old_price": "34.0",
        "new_price": "33.3"
      },
      {
        "name": "Silent Sentinel Supplies - Advanced",
        "old_price": "104.0",
        "new_price": "101.0"
      },
      {
        "name": "Black Hawk Down - Genesis",
        "old_price": "104.0",
        "new_price": "101.0"
      },
      {
        "name": "Black Hawk Down - Reshape",
        "old_price": "208.0",
        "new_price": "202.1"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Delta Force PC(Steam)",
    "image": "https://itemmania.s3.amazonaws.com/game/zYLxoRKC2Eztd9z4cBLAs48hYUIUzzS3ucJCLfDD.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2344",
    "package": [
      {
        "name": "60",
        "old_price": "34.0",
        "new_price": "31.6"
      },
      {
        "name": "300+20",
        "old_price": "175.0",
        "new_price": "133.7"
      },
      {
        "name": "680+70",
        "old_price": "345.0",
        "new_price": "263.5"
      },
      {
        "name": "1,280+200",
        "old_price": "690.0",
        "new_price": "508.5"
      },
      {
        "name": "3,280+670",
        "old_price": "1,730.0",
        "new_price": "1,257.7"
      },
      {
        "name": "6,480+1,620",
        "old_price": "3,460.0",
        "new_price": "2,477.3"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "MU Origin 3",
    "image": "https://itemmania.s3.amazonaws.com/game/Lu9LAflDi0XK1dFxGKskDO8HTRZqxd3b6uFfEjAm.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2234",
    "package": [
      {
        "name": "70",
        "old_price": "35.0",
        "new_price": "30.6"
      },
      {
        "name": "350",
        "old_price": "179.0",
        "new_price": "142.8"
      },
      {
        "name": "1,050",
        "old_price": "549.0",
        "new_price": "410.6"
      },
      {
        "name": "2,100",
        "old_price": "1,100.0",
        "new_price": "822.8"
      },
      {
        "name": "3,500",
        "old_price": "1,800.0",
        "new_price": "1,346.4"
      },
      {
        "name": "7,000",
        "old_price": "3,700.0",
        "new_price": "2,741.7"
      },
      {
        "name": "10,500",
        "old_price": "5,500.0",
        "new_price": "4,075.5"
      },
      {
        "name": "14,000",
        "old_price": "7,200.0",
        "new_price": "5,335.2"
      },
      {
        "name": "21,000",
        "old_price": "10,900.0",
        "new_price": "8,076.9"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Honkai: Star Rail",
    "image": "https://itemmania.s3.amazonaws.com/game/kBiAO3ZNqK2Ux7iFmuBMEXrSyRxaS80fA9Jkjabe.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/782",
    "package": [
      {
        "name": "Express Supply Pass",
        "old_price": "179.0",
        "new_price": "122.4"
      },
      {
        "name": "Express Supply Pass (x2)",
        "old_price": "358.0",
        "new_price": "244.8"
      },
      {
        "name": "Express Supply Pass (x3)",
        "old_price": "537.0",
        "new_price": "367.3"
      },
      {
        "name": "Express Supply Pass (x4)",
        "old_price": "716.0",
        "new_price": "489.7"
      },
      {
        "name": "Express Supply Pass (x5)",
        "old_price": "895.0",
        "new_price": "612.1"
      },
      {
        "name": "เหมาทุกแพ็คอย่างละครั้ง",
        "old_price": "7,367.0",
        "new_price": "4,766.4"
      },
      {
        "name": "60 (มี x2 ในเกม+60)",
        "old_price": "39.0",
        "new_price": "27.4"
      },
      {
        "name": "300+30 (มี x2 ในเกม+300)",
        "old_price": "179.0",
        "new_price": "122.9"
      },
      {
        "name": "980+110 (มี x2 ในเกม+980)",
        "old_price": "549.0",
        "new_price": "361.7"
      },
      {
        "name": "1,980+260 (มี x2 ในเกม+1980)",
        "old_price": "1,100.0",
        "new_price": "723.8"
      },
      {
        "name": "3,280+600 (มี x2 ในเกม+3,280)",
        "old_price": "1,800.0",
        "new_price": "1,184.4"
      },
      {
        "name": "6,480+1,600 (มี x2 ในเกม+6,480)",
        "old_price": "3,700.0",
        "new_price": "2,297.7"
      },
      {
        "name": "6,480+1,600 (x2)",
        "old_price": "7,400.0",
        "new_price": "4,595.4"
      },
      {
        "name": "6,480+1,600 (x3)",
        "old_price": "11,100.0",
        "new_price": "6,893.1"
      },
      {
        "name": "6,480+1,600 (x5)",
        "old_price": "18,500.0",
        "new_price": "11,488.5"
      },
      {
        "name": "6,480+1,600 (x10)",
        "old_price": "37,000.0",
        "new_price": "22,977.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Genshin Impact",
    "image": "https://itemmania.s3.amazonaws.com/game/xvGlALmq2hSyebPL6AXz5j5Nq8SmnKdIxKsELxdG.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/692",
    "package": [
      {
        "name": "Blessing of the Welkin Moon",
        "old_price": "179.0",
        "new_price": "116.5"
      },
      {
        "name": "Blessing of the Welkin Moon (x2)",
        "old_price": "358.0",
        "new_price": "233.0"
      },
      {
        "name": "Blessing of the Welkin Moon (x3)",
        "old_price": "537.0",
        "new_price": "349.5"
      },
      {
        "name": "Blessing of the Welkin Moon (x4)",
        "old_price": "716.0",
        "new_price": "466.1"
      },
      {
        "name": "Blessing of the Welkin Moon (x5)",
        "old_price": "895.0",
        "new_price": "582.6"
      },
      {
        "name": "เหมาทุกแพ็คอย่างละครั้ง",
        "old_price": "7,363.0",
        "new_price": "4,785.9"
      },
      {
        "name": "60 (มี x2 ในเกม+60)",
        "old_price": "35.0",
        "new_price": "27.4"
      },
      {
        "name": "300+30 (มี x2 ในเกม +300)",
        "old_price": "179.0",
        "new_price": "116.5"
      },
      {
        "name": "980+110 (มี x2 ในเกม +980)",
        "old_price": "549.0",
        "new_price": "361.7"
      },
      {
        "name": "1,980+260 (มี x2 ในเกม +1,980)",
        "old_price": "1,100.0",
        "new_price": "743.5"
      },
      {
        "name": "3,280+600 (มี x2 ในเกม +3,280)",
        "old_price": "1,800.0",
        "new_price": "1,198.8"
      },
      {
        "name": "6,480+1,600 (มี x2 ในเกม +6,480)",
        "old_price": "3,700.0",
        "new_price": "2,297.7"
      },
      {
        "name": "6,480+1,600 (x2)",
        "old_price": "7,400.0",
        "new_price": "4,595.4"
      },
      {
        "name": "6,480+1,600 (x3)",
        "old_price": "11,100.0",
        "new_price": "6,893.1"
      },
      {
        "name": "6,480+1,600 (x5)",
        "old_price": "18,500.0",
        "new_price": "11,488.5"
      },
      {
        "name": "6,480+1,600 (x10)",
        "old_price": "37,000.0",
        "new_price": "22,977.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Zenless Zone Zero",
    "image": "https://itemmania.s3.amazonaws.com/game/QFU1Bc4PzhyL1vPSH7ieTPWDgrGhwVVNSAuA74ls.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2298",
    "package": [
      {
        "name": "สมาชิก Inter-Knot (x1)",
        "old_price": "179.0",
        "new_price": "118.1"
      },
      {
        "name": "สมาชิก Inter-Knot (x2)",
        "old_price": "358.0",
        "new_price": "236.2"
      },
      {
        "name": "สมาชิก Inter-Knot (x3)",
        "old_price": "537.0",
        "new_price": "354.4"
      },
      {
        "name": "สมาชิก Inter-Knot (x4)",
        "old_price": "716.0",
        "new_price": "472.5"
      },
      {
        "name": "สมาชิก Inter-Knot (x5)",
        "old_price": "895.0",
        "new_price": "590.7"
      },
      {
        "name": "เหมาทุกแพ็กอย่างละครั้ง",
        "old_price": "7,363.0",
        "new_price": "4,741.7"
      },
      {
        "name": "60 (มี x2 ในเกม+60)",
        "old_price": "35.0",
        "new_price": "25.6"
      },
      {
        "name": "300+30 (มี x2 ในเกม+300)",
        "old_price": "179.0",
        "new_price": "117.9"
      },
      {
        "name": "980+110 (มี x2 ในเกม+980)",
        "old_price": "549.0",
        "new_price": "357.3"
      },
      {
        "name": "1,980+260 (มี x2 ในเกม+1,980)",
        "old_price": "1,100.0",
        "new_price": "713.9"
      },
      {
        "name": "3,280+600 (มี x2 ในเกม+3,280)",
        "old_price": "1,800.0",
        "new_price": "1,175.4"
      },
      {
        "name": "6,480+1,600 (มี x2 ในเกม+6,480)",
        "old_price": "3,700.0",
        "new_price": "2,308.8"
      },
      {
        "name": "6,480+1,600 (x2)",
        "old_price": "7,400.0",
        "new_price": "4,617.6"
      },
      {
        "name": "6,480+1,600 (x3)",
        "old_price": "11,100.0",
        "new_price": "6,926.4"
      },
      {
        "name": "6,480+1,600 (x5)",
        "old_price": "18,500.0",
        "new_price": "11,544.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                    \n            "
  },
  {
    "name": "Honkai Impact 3rd",
    "image": "https://itemmania.s3.amazonaws.com/game/9zKV8JcZpOQJBPTo2hDhGCZ82U2pikBJIEwXfeBl.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2378",
    "package": [
      {
        "name": "65 Crystals",
        "old_price": "35.0",
        "new_price": "28.6"
      },
      {
        "name": "330",
        "old_price": "179.0",
        "new_price": "122.4"
      },
      {
        "name": "660",
        "old_price": "349.0",
        "new_price": "243.9"
      },
      {
        "name": "1,320",
        "old_price": "729.0",
        "new_price": "489.8"
      },
      {
        "name": "3,300",
        "old_price": "1,800.0",
        "new_price": "1,144.8"
      },
      {
        "name": "6,600",
        "old_price": "3,700.0",
        "new_price": "2,253.3"
      },
      {
        "name": "65",
        "old_price": "35.0",
        "new_price": "28.6"
      },
      {
        "name": "330 B-Chips",
        "old_price": "179.0",
        "new_price": "122.4"
      },
      {
        "name": "990",
        "old_price": "549.0",
        "new_price": "365.6"
      },
      {
        "name": "1,320",
        "old_price": "729.0",
        "new_price": "485.5"
      },
      {
        "name": "1,980",
        "old_price": "1,100.0",
        "new_price": "723.8"
      },
      {
        "name": "3,300",
        "old_price": "1,800.0",
        "new_price": "1,144.8"
      },
      {
        "name": "6,600",
        "old_price": "3,700.0",
        "new_price": "2,253.3"
      },
      {
        "name": "Monthly - Card",
        "old_price": "179.0",
        "new_price": "128.1"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Wuthering Waves",
    "image": "https://itemmania.s3.amazonaws.com/game/Y7dC9gEAcmDRW3MVl0phncRYCSj17mLIljYpbeoe.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2364",
    "package": [
      {
        "name": "60",
        "old_price": "35.0",
        "new_price": "34.3"
      },
      {
        "name": "300+30",
        "old_price": "179.0",
        "new_price": "165.5"
      },
      {
        "name": "980+110",
        "old_price": "549.0",
        "new_price": "493.5"
      },
      {
        "name": "1,980+260",
        "old_price": "1,100.0",
        "new_price": "935.0"
      },
      {
        "name": "3,280+600",
        "old_price": "1,800.0",
        "new_price": "1,528.2"
      },
      {
        "name": "6,480+1,600",
        "old_price": "3,700.0",
        "new_price": "3,026.6"
      },
      {
        "name": "6,480 X 2 แพ็ก",
        "old_price": "7,400.0",
        "new_price": "6,053.2"
      },
      {
        "name": "6,480 X 3 แพ็ก",
        "old_price": "11,100.0",
        "new_price": "9,079.8"
      },
      {
        "name": "6,480 X 5 แพ็ก",
        "old_price": "18,500.0",
        "new_price": "15,133.0"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Mobile Legends Bang Bang (เฉพาะไอดี TH)",
    "image": "https://itemmania.s3.amazonaws.com/game/iRtKkbIVawuBkpMQKlvG1VEiYZK6oJILQXxUfKhG.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2192",
    "package": [
      {
        "name": "50+5 Diamonds",
        "old_price": "35.0",
        "new_price": "25.7"
      },
      {
        "name": "150+15 Diamonds",
        "old_price": "105.0",
        "new_price": "73.5"
      },
      {
        "name": "250+25 Diamonds",
        "old_price": "175.0",
        "new_price": "122.5"
      },
      {
        "name": "500+65 Diamonds",
        "old_price": "359.0",
        "new_price": "239.8"
      },
      {
        "name": "86 Diamonds",
        "old_price": "55.0",
        "new_price": "40.9"
      },
      {
        "name": "172 Diamonds",
        "old_price": "109.0",
        "new_price": "75.2"
      },
      {
        "name": "257 Diamonds",
        "old_price": "164.0",
        "new_price": "113.1"
      },
      {
        "name": "706 Diamonds",
        "old_price": "437.0",
        "new_price": "301.5"
      },
      {
        "name": "2,195 Diamonds",
        "old_price": "1,301.0",
        "new_price": "897.6"
      },
      {
        "name": "3,688 Diamonds",
        "old_price": "2,167.0",
        "new_price": "1,495.2"
      },
      {
        "name": "5,532 Diamonds",
        "old_price": "3,251.0",
        "new_price": "2,230.1"
      },
      {
        "name": "9,288 Diamonds",
        "old_price": "5,413.0",
        "new_price": "3,686.2"
      },
      {
        "name": "Twilight Pass",
        "old_price": "350.0",
        "new_price": "253.7"
      },
      {
        "name": "One time Weekly",
        "old_price": "70.0",
        "new_price": "48.1"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟไทยเท่านั้น!**1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอก Zone ID3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Mobile Legends Bang Bang (เฉพาะไอดี PH/RU)",
    "image": "https://itemmania.s3.amazonaws.com/game/75CGZSCsUSnvg29ttRhRvlZpRzaPZ5HyILFEDRwR.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2280",
    "package": [
      {
        "name": "Twilight Pass",
        "old_price": "300.0",
        "new_price": "287.1"
      },
      {
        "name": "One time Weekly",
        "old_price": "",
        "new_price": "60.0"
      },
      {
        "name": "223 Diamonds (203+20 Bonus)",
        "old_price": "120.0",
        "new_price": "100.5"
      },
      {
        "name": "336 Diamonds (303+33 Bonus)",
        "old_price": "188.0",
        "new_price": "150.7"
      },
      {
        "name": "570 Diamonds (504+66 Bonus)",
        "old_price": "300.0",
        "new_price": "251.1"
      },
      {
        "name": "1,163 Diamonds (1,007+156 Bonus)",
        "old_price": "600.0",
        "new_price": "489.0"
      },
      {
        "name": "2,398 Diamonds (2,015+383 Bonus)",
        "old_price": "1,200.0",
        "new_price": "978.0"
      },
      {
        "name": "6,042 Diamonds (5,035+1,007 Bonus)",
        "old_price": "3,000.0",
        "new_price": "2,439.0"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟ (เฉพาะ ID PH/RU) **1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอก Zone ID3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Mobile Legends Bang Bang (เฉพาะไอดี MY)",
    "image": "https://itemmania.s3.amazonaws.com/game/Tmj9eWAzo7CwsqwYWRRrn2FcdbrRjNQQHT9wIfTg.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2356",
    "package": [
      {
        "name": "140 (127+13 Bonus)",
        "old_price": "",
        "new_price": "87.0"
      },
      {
        "name": "284 (254+30 Bonus)",
        "old_price": "174.0",
        "new_price": "163.2"
      },
      {
        "name": "355 (317+38 Bonus)",
        "old_price": "218.0",
        "new_price": "195.1"
      },
      {
        "name": "429 (383+46 Bonus)",
        "old_price": "261.0",
        "new_price": "244.0"
      },
      {
        "name": "716 (633+83 Bonus)",
        "old_price": "435.0",
        "new_price": "387.5"
      },
      {
        "name": "1,446 (1,252+194 Bonus)",
        "old_price": "868.0",
        "new_price": "773.3"
      },
      {
        "name": "2,976 (2,501+475 Bonus)",
        "old_price": "1,740.0",
        "new_price": "1,538.1"
      },
      {
        "name": "7,502 (6,252+1,250 Bonus)",
        "old_price": "4,342.0",
        "new_price": "3,825.3"
      },
      {
        "name": "Twilight Pass",
        "old_price": "374.0",
        "new_price": "332.1"
      },
      {
        "name": "One time Weekly",
        "old_price": "74.0",
        "new_price": "67.6"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟมาเลเซียเท่านั้น!**1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอก Zone ID3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Mobile Legends Bang Bang (เฉพาะไอดี ID)",
    "image": "https://itemmania.s3.amazonaws.com/game/HjMH7KXhsaHoyKYYoMADH3UFgXkO02cLvtyqm3AO.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2354",
    "package": [
      {
        "name": "59 (53+6 Bonus)",
        "old_price": "40.0",
        "new_price": "38.2"
      },
      {
        "name": "85 (77+8 Bonus)",
        "old_price": "58.0",
        "new_price": "57.8"
      },
      {
        "name": "170 (154+16 Bonus)",
        "old_price": "115.0",
        "new_price": "106.8"
      },
      {
        "name": "240 (217+23 Bonus)",
        "old_price": "163.0",
        "new_price": "146.0"
      },
      {
        "name": "296 (256+40 Bonus)",
        "old_price": "200.0",
        "new_price": "175.4"
      },
      {
        "name": "408 (367+41 Bonus)",
        "old_price": "275.0",
        "new_price": "245.0"
      },
      {
        "name": "568 (503+65 Bonus)",
        "old_price": "375.0",
        "new_price": "322.5"
      },
      {
        "name": "875 (774+101 Bonus)",
        "old_price": "575.0",
        "new_price": "490.4"
      },
      {
        "name": "2,010 (1,708+302 Bonus)",
        "old_price": "1,250.0",
        "new_price": "1,057.5"
      },
      {
        "name": "4,830 (4,003+827 Bonus)",
        "old_price": "3,000.0",
        "new_price": "2,538.0"
      },
      {
        "name": "Twilight Pass",
        "old_price": "375.0",
        "new_price": "322.5"
      },
      {
        "name": "One time Weekly",
        "old_price": "75.0",
        "new_price": "68.0"
      }
    ],
    "cont": "\n                ** เติมไอดีเซิร์ฟอินโดนีเซียเท่านั้น!**1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอก Zone ID3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Racing Master",
    "image": "https://itemmania.s3.amazonaws.com/game/vbK7uiaBR9N1xOh3rQKNiCGNRZiy9XH5Vu2lAMNC.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2362",
    "package": [
      {
        "name": "70+4",
        "old_price": "30.0",
        "new_price": "27.5"
      },
      {
        "name": "350+18",
        "old_price": "159.0",
        "new_price": "132.6"
      },
      {
        "name": "700+35",
        "old_price": "329.0",
        "new_price": "263.5"
      },
      {
        "name": "1,000+50",
        "old_price": "479.0",
        "new_price": "367.8"
      },
      {
        "name": "1,400+70",
        "old_price": "669.0",
        "new_price": "513.7"
      },
      {
        "name": "2,100+105",
        "old_price": "999.0",
        "new_price": "763.2"
      },
      {
        "name": "3,400+170",
        "old_price": "1,590.0",
        "new_price": "1,230.6"
      },
      {
        "name": "6,600+330",
        "old_price": "3,090.0",
        "new_price": "2,348.4"
      },
      {
        "name": "Weekycard",
        "old_price": "30.0",
        "new_price": "28.4"
      },
      {
        "name": "Monthlycard",
        "old_price": "75.0",
        "new_price": "61.2"
      },
      {
        "name": "Deluxe MP (สัญญาซีซั่นขั้นสูง)",
        "old_price": "159.0",
        "new_price": "136.2"
      },
      {
        "name": "Premium MP (สัญญาซีซั่นพิเศษ)",
        "old_price": "309.0",
        "new_price": "246.8"
      },
      {
        "name": "MP Combo",
        "old_price": "789.0",
        "new_price": "618.5"
      },
      {
        "name": "Growth Fund (กองทุนพัฒนา)",
        "old_price": "210.0",
        "new_price": "165.6"
      },
      {
        "name": "Upgrade to the Premium MP",
        "old_price": "150.0",
        "new_price": "122.4"
      },
      {
        "name": "Value Outfit",
        "old_price": "30.0",
        "new_price": "28.4"
      },
      {
        "name": "Expo x 10",
        "old_price": "329.0",
        "new_price": "263.5"
      },
      {
        "name": "Expo x 15",
        "old_price": "479.0",
        "new_price": "371.2"
      },
      {
        "name": "Expo x 100",
        "old_price": "3,090.0",
        "new_price": "2,407.1"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "TFT: Teamfight Tactics",
    "image": "https://itemmania.s3.amazonaws.com/game/PIQumKF7zreHUsK3bud8mN4kDi45v5415CbzbGOO.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2202",
    "package": [
      {
        "name": "575",
        "old_price": "130.0",
        "new_price": "122.3"
      },
      {
        "name": "1,380",
        "old_price": "290.0",
        "new_price": "272.8"
      },
      {
        "name": "2,800",
        "old_price": "560.0",
        "new_price": "526.9"
      },
      {
        "name": "4,500",
        "old_price": "890.0",
        "new_price": "837.4"
      },
      {
        "name": "6,500",
        "old_price": "1,250.0",
        "new_price": "1,176.2"
      },
      {
        "name": "13,500",
        "old_price": "2,550.0",
        "new_price": "2,399.5"
      }
    ],
    "cont": "\n                1. กรอก Riot ID + Tag  -ดูได้โดยกดที่ โปรไฟล์และเอาเมาส์ชี้ไปที่ชื่อ จะแสดง Riot ID + Tag2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Identity V",
    "image": "https://itemmania.s3.amazonaws.com/game/SgalDJYxKpplSJyvbTA2DaWqC63xEoK7hJviRu1v.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2236",
    "package": [
      {
        "name": "60+6 กระดุมแดง",
        "old_price": "31.0",
        "new_price": "29.3"
      },
      {
        "name": "185+18 กระดุมแดง",
        "old_price": "93.0",
        "new_price": "88.0"
      },
      {
        "name": "305+30 กระดุมแดง",
        "old_price": "155.0",
        "new_price": "142.1"
      },
      {
        "name": "690+69 กระดุมแดง",
        "old_price": "310.0",
        "new_price": "283.3"
      },
      {
        "name": "2,025+202 กระดุมแดง",
        "old_price": "930.0",
        "new_price": "831.4"
      },
      {
        "name": "3,330+333 กระดุมแดง",
        "old_price": "1,550.0",
        "new_price": "1,385.7"
      },
      {
        "name": "6,590+659 กระดุมแดง",
        "old_price": "3,100.0",
        "new_price": "2,771.4"
      },
      {
        "name": "Inspirations Package",
        "old_price": "35.0",
        "new_price": "28.4"
      },
      {
        "name": "Clues Package",
        "old_price": "175.0",
        "new_price": "142.1"
      },
      {
        "name": "Memory Sphere PackageClues Package",
        "old_price": "345.0",
        "new_price": "289.8"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Mecha BREAK",
    "image": "https://itemmania.s3.amazonaws.com/game/IaWjqIQ3VT2q0CIoylIIK5JqPFsleK58Hlbxwdmp.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2380",
    "package": [
      {
        "name": "100",
        "old_price": "34.0",
        "new_price": "30.7"
      },
      {
        "name": "515",
        "old_price": "169.0",
        "new_price": "146.0"
      },
      {
        "name": "1,060",
        "old_price": "339.0",
        "new_price": "292.8"
      },
      {
        "name": "2,180",
        "old_price": "679.0",
        "new_price": "567.6"
      },
      {
        "name": "3,360",
        "old_price": "1,019.0",
        "new_price": "851.8"
      },
      {
        "name": "5,405",
        "old_price": "1,619.0",
        "new_price": "1,321.1"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Rememento: White Shadow",
    "image": "https://itemmania.s3.amazonaws.com/game/T3rXnw7xPh4JTupUTEBMCikNlSgOCfhOMWC43fQh.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2382",
    "package": [
      {
        "name": "60",
        "old_price": "29.0",
        "new_price": "28.0"
      },
      {
        "name": "300",
        "old_price": "149.0",
        "new_price": "139.4"
      },
      {
        "name": "980",
        "old_price": "449.0",
        "new_price": "420.2"
      },
      {
        "name": "1,980",
        "old_price": "899.0",
        "new_price": "841.4"
      },
      {
        "name": "3,280",
        "old_price": "1,600.0",
        "new_price": "1,481.6"
      },
      {
        "name": "6,480",
        "old_price": "3,000.0",
        "new_price": "2,778.0"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "EA Sport FC mobile",
    "image": "https://itemmania.s3.amazonaws.com/game/L7AoiohjVW5TvFrzsk0LRx5Bs4xcpD7CXBNUYQrb.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2256",
    "package": [
      {
        "name": "40",
        "old_price": "",
        "new_price": "15.0"
      },
      {
        "name": "100",
        "old_price": "35.0",
        "new_price": "34.0"
      },
      {
        "name": "520",
        "old_price": "179.0",
        "new_price": "171.4"
      },
      {
        "name": "1,070",
        "old_price": "349.0",
        "new_price": "333.2"
      },
      {
        "name": "2,200",
        "old_price": "729.0",
        "new_price": "695.4"
      },
      {
        "name": "5,750",
        "old_price": "1,800.0",
        "new_price": "1,713.6"
      },
      {
        "name": "12,000",
        "old_price": "3,700.0",
        "new_price": "3,522.4"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Ragnarok Crush",
    "image": "https://itemmania.s3.amazonaws.com/game/tQmwvV6b6xogjUr2OZ9304ClbK9uGOH1o7uIhydO.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2386",
    "package": [
      {
        "name": "99",
        "old_price": "35.0",
        "new_price": "32.3"
      },
      {
        "name": "499",
        "old_price": "165.0",
        "new_price": "146.0"
      },
      {
        "name": "999",
        "old_price": "330.0",
        "new_price": "297.0"
      },
      {
        "name": "1,499",
        "old_price": "495.0",
        "new_price": "436.0"
      },
      {
        "name": "1,999",
        "old_price": "660.0",
        "new_price": "576.8"
      },
      {
        "name": "2,499",
        "old_price": "825.0",
        "new_price": "714.4"
      },
      {
        "name": "2,999",
        "old_price": "990.0",
        "new_price": "851.4"
      },
      {
        "name": "3,499",
        "old_price": "1,155.0",
        "new_price": "982.9"
      },
      {
        "name": "4,999",
        "old_price": "1,650.0",
        "new_price": "1,404.1"
      },
      {
        "name": "9,999",
        "old_price": "3,300.0",
        "new_price": "2,808.3"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Ragnarok Landverse",
    "image": "https://itemmania.s3.amazonaws.com/game/r1pjnxS21Qlrci3wc9VGLfQXEuF4IVjPnAZcx4YK.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2318",
    "package": [
      {
        "name": "1,000 Moonstone",
        "old_price": "388.0",
        "new_price": "320.4"
      },
      {
        "name": "3,000 Moonstone",
        "old_price": "1,164.0",
        "new_price": "961.4"
      },
      {
        "name": "5,000 Moonstone",
        "old_price": "1,940.0",
        "new_price": "1,602.4"
      },
      {
        "name": "10,000 Moonstone",
        "old_price": "3,880.0",
        "new_price": "3,204.8"
      },
      {
        "name": "30,000 Moonstone",
        "old_price": "11,640.0",
        "new_price": "9,614.6"
      },
      {
        "name": "50,000 Moonstone",
        "old_price": "19,400.0",
        "new_price": "16,024.4"
      },
      {
        "name": "100,000 Moonstone",
        "old_price": "38,800.0",
        "new_price": "32,048.8"
      }
    ],
    "cont": "\n                1. กรอก Game ID * ไม่ใช่ Maxion ID *- ดูได้โดยที่ https://landverse.maxion.gg/Home > Launch App > Maxion Account > คัดลอก Game ID2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Ragnarok M: Classic",
    "image": "https://itemmania.s3.amazonaws.com/game/m1NKQsNmiodRcJOvaS5iUJyNrdEU7ZqEsFgD2Fxv.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2342",
    "package": [
      {
        "name": "1.8 ล้าน Zeny",
        "old_price": "105.0",
        "new_price": "90.7"
      },
      {
        "name": "3 ล้าน + 60,000 Zeny",
        "old_price": "169.0",
        "new_price": "146.0"
      },
      {
        "name": "6.8 ล้าน + 272,000 Zeny",
        "old_price": "340.0",
        "new_price": "293.0"
      },
      {
        "name": "12.8 ล้าน + 768,000 Zeny",
        "old_price": "610.0",
        "new_price": "525.8"
      },
      {
        "name": "32.8 ล้าน + 2.7 ล้าน Zeny",
        "old_price": "1,560.0",
        "new_price": "1,302.6"
      },
      {
        "name": "64.8 ล้าน + 7.2 ล้าน Zeny",
        "old_price": "3,050.0",
        "new_price": "2,507.1"
      },
      {
        "name": "หีบเสบียง Zeny 2 เท่าใหญ่ (สินค้ารายเดือน)",
        "old_price": "1,020.0",
        "new_price": "892.5"
      },
      {
        "name": "หีบเสบียง Zeny 2 เท่าเล็กน้อย (สินค้ารายเดือน)",
        "old_price": "340.0",
        "new_price": "302.9"
      },
      {
        "name": "Upgrade Adventure Log (Kafra Adventure Log)",
        "old_price": "235.0",
        "new_price": "205.6"
      },
      {
        "name": "Collection Adventure Log (Kafra Adventure Log)",
        "old_price": "800.0",
        "new_price": "692.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Ragnarok M: Eternal Love",
    "image": "https://itemmania.s3.amazonaws.com/game/xYlMGsBmqRqhUivvO49PmzYMrhVnsvVPtPZY5fkp.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/566",
    "package": [
      {
        "name": "VIP รายเดือน",
        "old_price": "289.0",
        "new_price": "228.8"
      },
      {
        "name": "14",
        "old_price": "68.0",
        "new_price": "57.8"
      },
      {
        "name": "28",
        "old_price": "136.0",
        "new_price": "115.6"
      },
      {
        "name": "72",
        "old_price": "332.0",
        "new_price": "293.1"
      },
      {
        "name": "145",
        "old_price": "664.0",
        "new_price": "586.3"
      },
      {
        "name": "290 (145 x 2)",
        "old_price": "1,328.0",
        "new_price": "1,172.6"
      },
      {
        "name": "435 (145 x 3)",
        "old_price": "1,992.0",
        "new_price": "1,758.9"
      },
      {
        "name": "748",
        "old_price": "3,420.0",
        "new_price": "2,807.8"
      },
      {
        "name": "1,496",
        "old_price": "6,641.0",
        "new_price": "5,624.9"
      },
      {
        "name": "2,992 (1,496 x 2)",
        "old_price": "13,282.0",
        "new_price": "11,249.8"
      },
      {
        "name": "4,488 (1,496 x 3)",
        "old_price": "19,923.0",
        "new_price": "16,874.7"
      },
      {
        "name": "5,984 (1,496 x 4)",
        "old_price": "26,564.0",
        "new_price": "22,499.7"
      },
      {
        "name": "7,480 (1,496 x 5)",
        "old_price": "33,205.0",
        "new_price": "28,124.6"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Ragnarok X: Next Generation",
    "image": "https://itemmania.s3.amazonaws.com/game/Hs9azkE8eQQlb9gWcwejNP7KkC1iMYtWMpTsZsaM.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/560",
    "package": [
      {
        "name": "เซอร์วิส W",
        "old_price": "500.0",
        "new_price": "420.5"
      },
      {
        "name": "2,360",
        "old_price": "170.0",
        "new_price": "143.4"
      },
      {
        "name": "4,720",
        "old_price": "341.0",
        "new_price": "291.8"
      },
      {
        "name": "9,490",
        "old_price": "687.0",
        "new_price": "583.9"
      },
      {
        "name": "19,380",
        "old_price": "1,365.0",
        "new_price": "1,027.8"
      },
      {
        "name": "51,840",
        "old_price": "3,582.0",
        "new_price": "3,084.1"
      },
      {
        "name": "98,100",
        "old_price": "6,780.0",
        "new_price": "5,023.9"
      },
      {
        "name": "196,200",
        "old_price": "13,559.0",
        "new_price": "10,074.3"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Ragnarok Origin",
    "image": "https://itemmania.s3.amazonaws.com/game/dNxXMRONaFDetjVqwQRdeBjvtyz6PJJ6wSfsPJ7f.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/748",
    "package": [
      {
        "name": "40",
        "old_price": "35.0",
        "new_price": "30.6"
      },
      {
        "name": "125",
        "old_price": "99.0",
        "new_price": "87.2"
      },
      {
        "name": "210",
        "old_price": "165.0",
        "new_price": "144.8"
      },
      {
        "name": "430",
        "old_price": "330.0",
        "new_price": "273.5"
      },
      {
        "name": "900",
        "old_price": "680.0",
        "new_price": "548.0"
      },
      {
        "name": "2,300",
        "old_price": "1,700.0",
        "new_price": "1,320.9"
      },
      {
        "name": "4,800",
        "old_price": "3,500.0",
        "new_price": "2,677.5"
      },
      {
        "name": "9,600 (4,800 x 2)",
        "old_price": "7,000.0",
        "new_price": "5,355.0"
      },
      {
        "name": "24,000 (4,800 x 5)",
        "old_price": "17,500.0",
        "new_price": "13,387.5"
      },
      {
        "name": "48,000 (4,800 x 10)",
        "old_price": "35,000.0",
        "new_price": "26,775.0"
      },
      {
        "name": "96,000 (4,800 x 20)",
        "old_price": "70,000.0",
        "new_price": "53,550.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "One Punch Man: The Strongest",
    "image": "https://itemmania.s3.amazonaws.com/game/hPC2i3EN2uINcro9ZF3d3Ah1jgQLg0zzD5SzxcpW.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/720",
    "package": [
      {
        "name": "6 คูปอง",
        "old_price": "28.0",
        "new_price": "24.5"
      },
      {
        "name": "37 คูปอง",
        "old_price": "172.0",
        "new_price": "151.0"
      },
      {
        "name": "109 คูปอง",
        "old_price": "510.0",
        "new_price": "441.1"
      },
      {
        "name": "362 คูปอง",
        "old_price": "1,700.0",
        "new_price": "1,450.1"
      },
      {
        "name": "904 คูปอง",
        "old_price": "4,245.0",
        "new_price": "3,476.6"
      },
      {
        "name": "1,808 คูปอง (904 x 2)",
        "old_price": "8,490.0",
        "new_price": "6,927.8"
      },
      {
        "name": "2,712 คูปอง (904 x 3)",
        "old_price": "12,735.0",
        "new_price": "10,340.8"
      },
      {
        "name": "4,520 คูปอง (904 x 5)",
        "old_price": "21,225.0",
        "new_price": "17,149.8"
      }
    ],
    "cont": "\n                1. กรอก UID และ SID ให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Ace Racer",
    "image": "https://itemmania.s3.amazonaws.com/game/S8jfGa4Y26GuZXeK7N1TBcxRS4cd1HaCa3me7g7r.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2164",
    "package": [
      {
        "name": "60+5",
        "old_price": "49.0",
        "new_price": "42.3"
      },
      {
        "name": "250+20",
        "old_price": "149.0",
        "new_price": "128.8"
      },
      {
        "name": "680+60",
        "old_price": "349.0",
        "new_price": "299.0"
      },
      {
        "name": "1,360+120 (680 x 2)",
        "old_price": "698.0",
        "new_price": "597.4"
      },
      {
        "name": "2,040+180 (680 x 3)",
        "old_price": "1,047.0",
        "new_price": "896.2"
      },
      {
        "name": "2,880+300",
        "old_price": "1,650.0",
        "new_price": "1,338.1"
      },
      {
        "name": "5,880+650",
        "old_price": "3,200.0",
        "new_price": "2,595.2"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Marvel Rivals",
    "image": "https://itemmania.s3.amazonaws.com/game/GpIHMO5JiQVhIag9zmBWIUnbuc40hfeuukDSHi78.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2346",
    "package": [
      {
        "name": "100",
        "old_price": "34.0",
        "new_price": "28.4"
      },
      {
        "name": "500",
        "old_price": "168.0",
        "new_price": "139.7"
      },
      {
        "name": "1,000",
        "old_price": "338.0",
        "new_price": "273.4"
      },
      {
        "name": "2,180",
        "old_price": "676.0",
        "new_price": "546.8"
      },
      {
        "name": "5,680",
        "old_price": "1,691.0",
        "new_price": "1,347.7"
      },
      {
        "name": "11,680",
        "old_price": "3,382.0",
        "new_price": "2,695.4"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Honor of Kings",
    "image": "https://itemmania.s3.amazonaws.com/game/CHV7guWDJcsFJsyMjQAf8piS5MEtlECbZ2yUlB5E.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2264",
    "package": [
      {
        "name": "240",
        "old_price": "99.0",
        "new_price": "97.0"
      },
      {
        "name": "400",
        "old_price": "199.0",
        "new_price": "163.9"
      },
      {
        "name": "560",
        "old_price": "279.0",
        "new_price": "234.3"
      },
      {
        "name": "830",
        "old_price": "399.0",
        "new_price": "317.6"
      },
      {
        "name": "1,245",
        "old_price": "499.0",
        "new_price": "479.0"
      },
      {
        "name": "2,508",
        "old_price": "999.0",
        "new_price": "930.0"
      },
      {
        "name": "4,180",
        "old_price": "1,990.0",
        "new_price": "1,478.5"
      },
      {
        "name": "8,360",
        "old_price": "3,990.0",
        "new_price": "2,976.5"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Cabal Infinite Combo",
    "image": "https://itemmania.s3.amazonaws.com/game/zjCZevMtPbM5I0eWpOR7yEVJTTAbJQwgIWK2qRpq.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2302",
    "package": [
      {
        "name": "200 วอลเล็ตพอยท์",
        "old_price": "",
        "new_price": "20.0"
      },
      {
        "name": "1,000 วอลเล็ตพอยท์",
        "old_price": "100.0",
        "new_price": "98.0"
      },
      {
        "name": "5,000 วอลเล็ตพอยท์",
        "old_price": "500.0",
        "new_price": "490.0"
      },
      {
        "name": "10,000 วอลเล็ตพอยท์",
        "old_price": "1,000.0",
        "new_price": "980.0"
      },
      {
        "name": "103,000 วอลเล็ตพอยท์",
        "old_price": "10,000.0",
        "new_price": "9,800.0"
      },
      {
        "name": "525,000 วอลเล็ตพอยท์",
        "old_price": "50,000.0",
        "new_price": "49,000.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ AID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Cabal Ultimate Combo PC",
    "image": "https://itemmania.s3.amazonaws.com/game/XbMGUD7SpiKheG3jgr2teLkF4Ll4EkziBIX9dfhT.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2336",
    "package": [
      {
        "name": "200 วอลเล็ตพอยท์",
        "old_price": "20.0",
        "new_price": "19.9"
      },
      {
        "name": "1,000 วอลเล็ตพอยท์",
        "old_price": "100.0",
        "new_price": "99.8"
      },
      {
        "name": "5,000 วอลเล็ตพอยท์",
        "old_price": "500.0",
        "new_price": "498.5"
      },
      {
        "name": "10,000 วอลเล็ตพอยท์",
        "old_price": "1,000.0",
        "new_price": "996.0"
      },
      {
        "name": "100,000 วอลเล็ตพอยท์",
        "old_price": "10,000.0",
        "new_price": "9,950.0"
      },
      {
        "name": "500,000 วอลเล็ตพอยท์",
        "old_price": "50,000.0",
        "new_price": "49,700.0"
      },
      {
        "name": "1,000,000 วอลเล็ตพอยท์",
        "old_price": "100,000.0",
        "new_price": "99,300.0"
      }
    ],
    "cont": "\n                Cabal Ultimate Combo PC1. ตรวจสอบ AID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Goddess of Victory: NIKKE",
    "image": "https://itemmania.s3.amazonaws.com/game/qNsf7uexfoqd9mOjDGjxsvdJtYwljdqMiuNaWk5f.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/712",
    "package": [
      {
        "name": "2,300",
        "old_price": "1,100.0",
        "new_price": "905.3"
      },
      {
        "name": "4,200",
        "old_price": "2,000.0",
        "new_price": "1,646.0"
      },
      {
        "name": "6,200",
        "old_price": "2,900.0",
        "new_price": "2,351.9"
      },
      {
        "name": "12,400 (6,200 x 2)",
        "old_price": "5,800.0",
        "new_price": "4,703.8"
      },
      {
        "name": "18,600 (6,200 x 3)",
        "old_price": "8,700.0",
        "new_price": "7,055.7"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Devil May Cry: Peak of Combat",
    "image": "https://itemmania.s3.amazonaws.com/game/WaDwF5VY896zpUdrwSabvj8EZP371cUUR4sieUOu.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2262",
    "package": [
      {
        "name": "60",
        "old_price": "35.0",
        "new_price": "28.4"
      },
      {
        "name": "300",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "680",
        "old_price": "379.0",
        "new_price": "292.9"
      },
      {
        "name": "1,280",
        "old_price": "749.0",
        "new_price": "577.4"
      },
      {
        "name": "3,280",
        "old_price": "1,990.0",
        "new_price": "1,518.3"
      },
      {
        "name": "6,480",
        "old_price": "3,890.0",
        "new_price": "2,944.7"
      },
      {
        "name": "12,980",
        "old_price": "7,290.0",
        "new_price": "5,518.5"
      },
      {
        "name": "19,480",
        "old_price": "10,990.0",
        "new_price": "8,319.4"
      },
      {
        "name": "32,480",
        "old_price": "19,990.0",
        "new_price": "15,092.4"
      },
      {
        "name": "Daily Value Gem Pack I",
        "old_price": "79.0",
        "new_price": "63.7"
      },
      {
        "name": "Daily Mega Gem Pack II",
        "old_price": "109.0",
        "new_price": "87.2"
      },
      {
        "name": "Daily Gem Luxury Pack III",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Weekly Gem Luxury Pack",
        "old_price": "379.0",
        "new_price": "292.9"
      },
      {
        "name": "Epic Weapon Selection",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Epic Hunter Selection",
        "old_price": "379.0",
        "new_price": "292.9"
      },
      {
        "name": "Random Fragment Pack",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Advanced Rune Selection",
        "old_price": "549.0",
        "new_price": "420.5"
      },
      {
        "name": "Hunter Supreme Pack",
        "old_price": "1,990.0",
        "new_price": "1,518.3"
      },
      {
        "name": "Weapon Supreme Pack",
        "old_price": "1,990.0",
        "new_price": "1,518.3"
      },
      {
        "name": "Hunter Premium Pack",
        "old_price": "1,990.0",
        "new_price": "1,518.3"
      },
      {
        "name": "Red Orb Pack",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Hunter EXP Pack",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Weapon EXP Pack",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Card EXP Pack",
        "old_price": "179.0",
        "new_price": "146.0"
      },
      {
        "name": "Skill Manual Pack",
        "old_price": "379.0",
        "new_price": "292.9"
      },
      {
        "name": "Crimson Scale Pack",
        "old_price": "379.0",
        "new_price": "292.9"
      },
      {
        "name": "Eye of the Abyss Pack",
        "old_price": "379.0",
        "new_price": "292.9"
      },
      {
        "name": "Eye of Destruction Pack",
        "old_price": "379.0",
        "new_price": "292.9"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Harry Potter: Magic Awakened",
    "image": "https://itemmania.s3.amazonaws.com/game/jPmlTmdXrVkevMbH61PjETlYtOVAGf13FDGbMcMT.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2034",
    "package": [
      {
        "name": "60 Jewels",
        "old_price": "35.0",
        "new_price": "28.4"
      },
      {
        "name": "300 Jewels",
        "old_price": "179.0",
        "new_price": "144.2"
      },
      {
        "name": "680+70 Jewels",
        "old_price": "379.0",
        "new_price": "301.6"
      },
      {
        "name": "980+165 Jewels",
        "old_price": "539.0",
        "new_price": "429.0"
      },
      {
        "name": "1,280+270 Jewels",
        "old_price": "699.0",
        "new_price": "556.4"
      },
      {
        "name": "1,980+380 Jewels",
        "old_price": "1,090.0",
        "new_price": "819.6"
      },
      {
        "name": "3,280+780 Jewels",
        "old_price": "1,800.0",
        "new_price": "1,353.6"
      },
      {
        "name": "6,480+2,000 Jewels",
        "old_price": "3,550.0",
        "new_price": "2,669.6"
      }
    ],
    "cont": "\n                1. ตรวจสอบ User ID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Undawn",
    "image": "https://itemmania.s3.amazonaws.com/game/2XuCXAyjeg8QMboE5ICtcPxhTY3t8Sm0sMnw5Lfq.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2266",
    "package": [
      {
        "name": "55 (ไม่ผูกการีน่า)",
        "old_price": "",
        "new_price": "20.0"
      },
      {
        "name": "138 (ไม่ผูกการีน่า)",
        "old_price": "50.0",
        "new_price": "49.0"
      },
      {
        "name": "253 (ไม่ผูกการีน่า)",
        "old_price": "90.0",
        "new_price": "87.0"
      },
      {
        "name": "440 (ไม่ผูกการีน่า)",
        "old_price": "150.0",
        "new_price": "145.0"
      },
      {
        "name": "880 (ไม่ผูกการีน่า)",
        "old_price": "300.0",
        "new_price": "285.0"
      },
      {
        "name": "1,485 (ไม่ผูกการีน่า)",
        "old_price": "500.0",
        "new_price": "475.0"
      },
      {
        "name": "2,970 (ไม่ผูกการีน่า)",
        "old_price": "",
        "new_price": "1,000.0"
      },
      {
        "name": "4,510 (ไม่ผูกการีน่า)",
        "old_price": "1,500.0",
        "new_price": "1,425.0"
      },
      {
        "name": "6,050 (ไม่ผูกการีน่า)",
        "old_price": "2,000.0",
        "new_price": "1,900.0"
      },
      {
        "name": "9,218 (ไม่ผูกการีน่า)",
        "old_price": "3,000.0",
        "new_price": "2,850.0"
      },
      {
        "name": "15,642 (ไม่ผูกการีน่า)",
        "old_price": "5,000.0",
        "new_price": "4,750.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Revelation M",
    "image": "https://itemmania.s3.amazonaws.com/game/jGnTfKfvSepLFXFO4377FMWAKHL9e11JgwraxiIZ.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2188",
    "package": [
      {
        "name": "40+6",
        "old_price": "23.0",
        "new_price": "22.5"
      },
      {
        "name": "110+17",
        "old_price": "58.0",
        "new_price": "51.4"
      },
      {
        "name": "230+35",
        "old_price": "115.0",
        "new_price": "102.0"
      },
      {
        "name": "460+69",
        "old_price": "230.0",
        "new_price": "204.0"
      },
      {
        "name": "920+138",
        "old_price": "460.0",
        "new_price": "408.0"
      },
      {
        "name": "1,150+173",
        "old_price": "575.0",
        "new_price": "510.0"
      },
      {
        "name": "1,380+207",
        "old_price": "690.0",
        "new_price": "612.0"
      },
      {
        "name": "1,610+242",
        "old_price": "805.0",
        "new_price": "714.0"
      },
      {
        "name": "2,300+345",
        "old_price": "1,150.0",
        "new_price": "969.4"
      },
      {
        "name": "3,220+483",
        "old_price": "1,610.0",
        "new_price": "1,328.2"
      },
      {
        "name": "4,600+690",
        "old_price": "2,300.0",
        "new_price": "1,897.5"
      },
      {
        "name": "9,200+1,380",
        "old_price": "4,600.0",
        "new_price": "3,795.0"
      },
      {
        "name": "23,000+3,450",
        "old_price": "11,500.0",
        "new_price": "9,487.5"
      },
      {
        "name": "Classic Monthly Card",
        "old_price": "150.0",
        "new_price": "132.6"
      },
      {
        "name": "Superior Monthly Card",
        "old_price": "300.0",
        "new_price": "265.2"
      },
      {
        "name": "Daily Gift Combo 7 Day",
        "old_price": "1,050.0",
        "new_price": "949.2"
      },
      {
        "name": "Growth Fund - ทุนเติบโต",
        "old_price": "300.0",
        "new_price": "265.2"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "NBA Infinite",
    "image": "https://itemmania.s3.amazonaws.com/game/Btq9npUw20UG36BSB1viDGeobiXFoLBtKdodsgjf.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2268",
    "package": [
      {
        "name": "100 (+30 Dia)",
        "old_price": "",
        "new_price": "35.0"
      },
      {
        "name": "200 (+60 Dia)",
        "old_price": "",
        "new_price": "70.0"
      },
      {
        "name": "500 (+150 Dia)",
        "old_price": "180.0",
        "new_price": "175.3"
      },
      {
        "name": "1,000 (+300 Dia)",
        "old_price": "360.0",
        "new_price": "332.2"
      },
      {
        "name": "2,000 (+600 Dia)",
        "old_price": "720.0",
        "new_price": "638.6"
      },
      {
        "name": "3,000 (+900 Dia)",
        "old_price": "1,080.0",
        "new_price": "957.9"
      },
      {
        "name": "5,000 (+1,500 Dia)",
        "old_price": "1,800.0",
        "new_price": "1,596.6"
      },
      {
        "name": "10,000 (+3,000 Dia) (5,000 x 2)",
        "old_price": "3,600.0",
        "new_price": "3,193.2"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "TSX by Astronize",
    "image": "https://itemmania.s3.amazonaws.com/game/V1kThAsUQYXP8ZtNkzAB8EcNP4zdsCTnwCdIZwvd.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2272",
    "package": [
      {
        "name": "70",
        "old_price": "69.0",
        "new_price": "66.9"
      },
      {
        "name": "175",
        "old_price": "179.0",
        "new_price": "165.5"
      },
      {
        "name": "350",
        "old_price": "349.0",
        "new_price": "322.4"
      },
      {
        "name": "920",
        "old_price": "899.0",
        "new_price": "783.0"
      },
      {
        "name": "1,940",
        "old_price": "1,800.0",
        "new_price": "1,566.0"
      },
      {
        "name": "3,950",
        "old_price": "3,700.0",
        "new_price": "3,133.9"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "ZEPETO",
    "image": "https://itemmania.s3.amazonaws.com/game/lw7Jbr12NHWGQ8x6Y80k9Z381vmyQssxieWJjQpA.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2150",
    "package": [
      {
        "name": "4,680",
        "old_price": "40.0",
        "new_price": "35.7"
      },
      {
        "name": "9,700",
        "old_price": "80.0",
        "new_price": "66.3"
      },
      {
        "name": "25,200",
        "old_price": "200.0",
        "new_price": "163.2"
      },
      {
        "name": "40,700",
        "old_price": "320.0",
        "new_price": "253.7"
      },
      {
        "name": "110,000",
        "old_price": "850.0",
        "new_price": "640.0"
      },
      {
        "name": "300,000",
        "old_price": "2,320.0",
        "new_price": "1,698.2"
      },
      {
        "name": "14",
        "old_price": "40.0",
        "new_price": "36.8"
      },
      {
        "name": "28",
        "old_price": "80.0",
        "new_price": "66.3"
      },
      {
        "name": "58",
        "old_price": "160.0",
        "new_price": "126.4"
      },
      {
        "name": "128",
        "old_price": "349.0",
        "new_price": "265.2"
      },
      {
        "name": "323",
        "old_price": "880.0",
        "new_price": "660.0"
      },
      {
        "name": "1,000",
        "old_price": "2,690.0",
        "new_price": "1,977.1"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Octopath Traveler",
    "image": "https://itemmania.s3.amazonaws.com/game/S0WqpTa5864IroF4dTIvhC1gCzDBqpXXdMczznhG.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2270",
    "package": [
      {
        "name": "Monthly Ruby Set A",
        "old_price": "599.0",
        "new_price": "558.8"
      },
      {
        "name": "Monthly Ruby Set B",
        "old_price": "1,990.0",
        "new_price": "1,866.6"
      },
      {
        "name": "Level Up Pack",
        "old_price": "",
        "new_price": "99.0"
      },
      {
        "name": "Level Up Bonus",
        "old_price": "399.0",
        "new_price": "382.2"
      },
      {
        "name": "Limit Break Pack",
        "old_price": "999.0",
        "new_price": "960.0"
      },
      {
        "name": "Novice's Pack",
        "old_price": "1,190.0",
        "new_price": "1,071.0"
      },
      {
        "name": "60+3",
        "old_price": "129.0",
        "new_price": "125.0"
      },
      {
        "name": "160+8",
        "old_price": "349.0",
        "new_price": "315.1"
      },
      {
        "name": "290+15",
        "old_price": "599.0",
        "new_price": "558.8"
      },
      {
        "name": "480+24",
        "old_price": "999.0",
        "new_price": "915.0"
      },
      {
        "name": "1,000+50",
        "old_price": "1,990.0",
        "new_price": "1,866.6"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Sausage Man",
    "image": "https://itemmania.s3.amazonaws.com/game/70I1i05xiRJ9iZ5DDbhHaWbxvzvrO0EPCfQmiTXw.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2206",
    "package": [
      {
        "name": "186",
        "old_price": "99.0",
        "new_price": "95.0"
      },
      {
        "name": "318",
        "old_price": "179.0",
        "new_price": "155.7"
      },
      {
        "name": "686",
        "old_price": "349.0",
        "new_price": "293.1"
      },
      {
        "name": "1,378",
        "old_price": "729.0",
        "new_price": "557.6"
      },
      {
        "name": "2,118",
        "old_price": "1,100.0",
        "new_price": "831.6"
      },
      {
        "name": "3,548",
        "old_price": "1,800.0",
        "new_price": "1,360.8"
      },
      {
        "name": "7,108",
        "old_price": "3,700.0",
        "new_price": "2,678.8"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Metal Slug: Awakening",
    "image": "https://itemmania.s3.amazonaws.com/game/2EDPDu4fewbwUb5d4DOv0corG8Uv6zTq8c0xiyxZ.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2158",
    "package": [
      {
        "name": "บัตรเดือนสุดคุ้ม",
        "old_price": "150.0",
        "new_price": "140.1"
      },
      {
        "name": "บัตรเดือนสุดหรู",
        "old_price": "300.0",
        "new_price": "279.3"
      },
      {
        "name": "310",
        "old_price": "150.0",
        "new_price": "140.1"
      },
      {
        "name": "630",
        "old_price": "300.0",
        "new_price": "279.3"
      },
      {
        "name": "1,300",
        "old_price": "600.0",
        "new_price": "558.6"
      },
      {
        "name": "3,200",
        "old_price": "1,500.0",
        "new_price": "1,396.5"
      },
      {
        "name": "6,500",
        "old_price": "3,000.0",
        "new_price": "2,793.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Street Fighter: Duel",
    "image": "https://itemmania.s3.amazonaws.com/game/SgzF9UsDgBQqEKx61xepZfJ3ybCly24SpZwImMW1.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2284",
    "package": [
      {
        "name": "599",
        "old_price": "199.0",
        "new_price": "146.0"
      },
      {
        "name": "1,199",
        "old_price": "399.0",
        "new_price": "283.2"
      },
      {
        "name": "2,399",
        "old_price": "699.0",
        "new_price": "556.4"
      },
      {
        "name": "3,599",
        "old_price": "999.0",
        "new_price": "851.1"
      },
      {
        "name": "5,999",
        "old_price": "1,990.0",
        "new_price": "1,538.2"
      },
      {
        "name": "11,999",
        "old_price": "3,990.0",
        "new_price": "2,777.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "ASTRA: Knights of Veda",
    "image": "https://itemmania.s3.amazonaws.com/game/L2ap1273PAtOb9kXUThx6Iwn9D6JCnKUkvimqNTN.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2286",
    "package": [
      {
        "name": "60",
        "old_price": "",
        "new_price": "29.0"
      },
      {
        "name": "300",
        "old_price": "176.0",
        "new_price": "175.4"
      },
      {
        "name": "980",
        "old_price": "469.0",
        "new_price": "459.6"
      },
      {
        "name": "1,980",
        "old_price": "1,050.0",
        "new_price": "1,025.8"
      },
      {
        "name": "3,280",
        "old_price": "1,754.0",
        "new_price": "1,713.6"
      },
      {
        "name": "6,480",
        "old_price": "2,928.0",
        "new_price": "2,828.4"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Light of Thel: New Era",
    "image": "https://itemmania.s3.amazonaws.com/game/XFTm3NoOlZRjf47MsM6iIRUlVuGGFrGkHH9usq39.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/949",
    "package": [
      {
        "name": "90",
        "old_price": "",
        "new_price": "35.0"
      },
      {
        "name": "450",
        "old_price": "179.0",
        "new_price": "161.8"
      },
      {
        "name": "630",
        "old_price": "249.0",
        "new_price": "220.3"
      },
      {
        "name": "900",
        "old_price": "349.0",
        "new_price": "308.8"
      },
      {
        "name": "1,350",
        "old_price": "549.0",
        "new_price": "431.5"
      },
      {
        "name": "1,800",
        "old_price": "729.0",
        "new_price": "572.9"
      },
      {
        "name": "2,250",
        "old_price": "899.0",
        "new_price": "706.6"
      },
      {
        "name": "2,980",
        "old_price": "1,200.0",
        "new_price": "936.0"
      },
      {
        "name": "4,500",
        "old_price": "1,800.0",
        "new_price": "1,404.0"
      },
      {
        "name": "6,300",
        "old_price": "2,500.0",
        "new_price": "1,950.0"
      },
      {
        "name": "9,000",
        "old_price": "3,700.0",
        "new_price": "2,808.3"
      },
      {
        "name": "15,000",
        "old_price": "5,550.0",
        "new_price": "4,212.4"
      },
      {
        "name": "32,000",
        "old_price": "11,100.0",
        "new_price": "8,424.9"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Legends of Runeterra",
    "image": "https://itemmania.s3.amazonaws.com/game/CARDFVgBIEiowkOL1YzcAh0dX6zxn592PhWPl2pE.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2290",
    "package": [
      {
        "name": "475",
        "old_price": "150.0",
        "new_price": "141.1"
      },
      {
        "name": "1,000",
        "old_price": "300.0",
        "new_price": "282.3"
      },
      {
        "name": "2,050",
        "old_price": "600.0",
        "new_price": "564.6"
      },
      {
        "name": "3,650",
        "old_price": "1,050.0",
        "new_price": "988.0"
      },
      {
        "name": "5,350",
        "old_price": "1,450.0",
        "new_price": "1,364.4"
      },
      {
        "name": "11,000",
        "old_price": "2,900.0",
        "new_price": "2,728.9"
      }
    ],
    "cont": "\n                1. กรอก Riot ID + Tag  -ดูได้โดยกดที่ โปรไฟล์และเอาเมาส์ชี้ไปที่ชื่อ จะแสดง Riot ID + Tag2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "PUBG NEWSTATE",
    "image": "https://itemmania.s3.amazonaws.com/game/TnTs1PTGNIQk3ROinthM0aFdAVTiRWtxY9jH0M2T.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2312",
    "package": [
      {
        "name": "300",
        "old_price": "35.0",
        "new_price": "34.3"
      },
      {
        "name": "1,500 (+80 bonus)",
        "old_price": "199.0",
        "new_price": "156.8"
      },
      {
        "name": "3,600 (+250 bonus)",
        "old_price": "399.0",
        "new_price": "381.0"
      },
      {
        "name": "9,300 (+930 bonus)",
        "old_price": "999.0",
        "new_price": "979.0"
      },
      {
        "name": "15,000 (+1,800 bonus)",
        "old_price": "1,990.0",
        "new_price": "1,578.0"
      },
      {
        "name": "30,000 (+5,000 bonus)",
        "old_price": "3,990.0",
        "new_price": "3,136.1"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Never After",
    "image": "https://itemmania.s3.amazonaws.com/game/WpJaH7YisTYL20FzMqONwiJxO4WabEpLUpUG2m4g.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2292",
    "package": [
      {
        "name": "Daily Feedback",
        "old_price": "109.0",
        "new_price": "99.0"
      },
      {
        "name": "Daily Selection",
        "old_price": "182.0",
        "new_price": "159.0"
      },
      {
        "name": "Daily Specials",
        "old_price": "36.0",
        "new_price": "35.0"
      },
      {
        "name": "Great Adventure",
        "old_price": "547.0",
        "new_price": "489.0"
      },
      {
        "name": "Growth Fund",
        "old_price": "475.0",
        "new_price": "429.4"
      },
      {
        "name": "Premium Pass",
        "old_price": "365.0",
        "new_price": "339.0"
      },
      {
        "name": "Promotion Pass",
        "old_price": "145.0",
        "new_price": "129.0"
      },
      {
        "name": "Senior Adventure",
        "old_price": "182.0",
        "new_price": "159.0"
      },
      {
        "name": "69",
        "old_price": "36.0",
        "new_price": "35.0"
      },
      {
        "name": "349+17",
        "old_price": "182.0",
        "new_price": "159.0"
      },
      {
        "name": "629+41",
        "old_price": "328.0",
        "new_price": "289.2"
      },
      {
        "name": "1,049+85",
        "old_price": "547.0",
        "new_price": "489.0"
      },
      {
        "name": "1,399+153",
        "old_price": "730.0",
        "new_price": "669.4"
      },
      {
        "name": "2,099+254",
        "old_price": "1,095.0",
        "new_price": "999.7"
      },
      {
        "name": "3,549+432",
        "old_price": "1,826.0",
        "new_price": "1,679.9"
      },
      {
        "name": "7,299+1,802",
        "old_price": "3,650.0",
        "new_price": "3,350.7"
      },
      {
        "name": "14,999+3,703",
        "old_price": "7,300.0",
        "new_price": "6,402.1"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Dragon Raja (SEA)",
    "image": "https://itemmania.s3.amazonaws.com/game/2sQHAZ10DT1AhyN7iFv3UfrJJpBfWLL9F8mnREmW.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/584",
    "package": [
      {
        "name": "Investment Fund",
        "old_price": "499.0",
        "new_price": "489.0"
      },
      {
        "name": "Investment Fund II",
        "old_price": "699.0",
        "new_price": "649.3"
      },
      {
        "name": "125",
        "old_price": "60.0",
        "new_price": "59.0"
      },
      {
        "name": "312",
        "old_price": "150.0",
        "new_price": "149.1"
      },
      {
        "name": "652",
        "old_price": "300.0",
        "new_price": "295.2"
      },
      {
        "name": "1,151",
        "old_price": "500.0",
        "new_price": "489.0"
      },
      {
        "name": "2,357",
        "old_price": "1,000.0",
        "new_price": "949.0"
      },
      {
        "name": "3,550",
        "old_price": "1,500.0",
        "new_price": "1,419.0"
      },
      {
        "name": "7,092",
        "old_price": "3,000.0",
        "new_price": "2,799.0"
      },
      {
        "name": "12,074",
        "old_price": "5,000.0",
        "new_price": "4,700.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Seal M",
    "image": "https://itemmania.s3.amazonaws.com/game/XdgscAG0SOoDHSNBSxWqtAiOhIgn1ApYm2vWN27K.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/935",
    "package": [
      {
        "name": "150",
        "old_price": "50.0",
        "new_price": "37.5"
      },
      {
        "name": "310",
        "old_price": "100.0",
        "new_price": "75.0"
      },
      {
        "name": "1,580",
        "old_price": "500.0",
        "new_price": "357.5"
      },
      {
        "name": "3,250",
        "old_price": "1,000.0",
        "new_price": "681.0"
      },
      {
        "name": "10,000",
        "old_price": "3,000.0",
        "new_price": "1,998.0"
      },
      {
        "name": "17,500",
        "old_price": "5,000.0",
        "new_price": "3,330.0"
      },
      {
        "name": "35,400",
        "old_price": "10,000.0",
        "new_price": "6,660.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ CS Code และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Supersus",
    "image": "https://itemmania.s3.amazonaws.com/game/555Z6K5cRgN07BWjUm20VIUaJPp9wNnkFRFQLGTr.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2314",
    "package": [
      {
        "name": "100",
        "old_price": "36.0",
        "new_price": "27.8"
      },
      {
        "name": "310",
        "old_price": "110.0",
        "new_price": "77.6"
      },
      {
        "name": "520",
        "old_price": "175.0",
        "new_price": "123.5"
      },
      {
        "name": "1,060",
        "old_price": "350.0",
        "new_price": "236.9"
      },
      {
        "name": "2,180",
        "old_price": "725.0",
        "new_price": "477.0"
      },
      {
        "name": "5,600",
        "old_price": "1,800.0",
        "new_price": "1,184.4"
      }
    ],
    "cont": "\n                1. ตรวจสอบ Player Space ID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Life After",
    "image": "https://itemmania.s3.amazonaws.com/game/y4ePh6jGQfsCg6DL7E4ANasIDxTqbudHKgCHBWTo.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2310",
    "package": [
      {
        "name": "65",
        "old_price": "50.0",
        "new_price": "39.0"
      },
      {
        "name": "330",
        "old_price": "200.0",
        "new_price": "155.0"
      },
      {
        "name": "558",
        "old_price": "300.0",
        "new_price": "245.1"
      },
      {
        "name": "1,108",
        "old_price": "500.0",
        "new_price": "455.0"
      },
      {
        "name": "2,268",
        "old_price": "1,000.0",
        "new_price": "929.0"
      },
      {
        "name": "3,468",
        "old_price": "1,550.0",
        "new_price": "1,399.6"
      },
      {
        "name": "5,768",
        "old_price": "2,475.0",
        "new_price": "2,299.2"
      },
      {
        "name": "7,768",
        "old_price": "3,300.0",
        "new_price": "2,999.7"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. กรอกชื่อตัวละคร4. เลือกแพ็กเกจ5. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ6. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้7. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Autochess",
    "image": "https://itemmania.s3.amazonaws.com/game/kfRG3qo5M3nfkMDTCMpb46TNcg4nLXvG2rVdKHNH.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2300",
    "package": [
      {
        "name": "114",
        "old_price": "50.0",
        "new_price": "49.0"
      },
      {
        "name": "230",
        "old_price": "100.0",
        "new_price": "97.0"
      },
      {
        "name": "344",
        "old_price": "150.0",
        "new_price": "145.0"
      },
      {
        "name": "516",
        "old_price": "200.0",
        "new_price": "195.0"
      },
      {
        "name": "742",
        "old_price": "300.0",
        "new_price": "280.2"
      },
      {
        "name": "1,257",
        "old_price": "500.0",
        "new_price": "475.0"
      },
      {
        "name": "2,454",
        "old_price": "1,000.0",
        "new_price": "935.0"
      },
      {
        "name": "8,828",
        "old_price": "3,500.0",
        "new_price": "3,230.5"
      }
    ],
    "cont": "\n                1. ตรวจสอบ User ID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\"\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Speed drifters",
    "image": "https://itemmania.s3.amazonaws.com/game/TN6Hy0MFzYb5f6NAixabycGQDbh3A3WciIVQuZRd.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2260",
    "package": [
      {
        "name": "56",
        "old_price": "35.0",
        "new_price": "26.5"
      },
      {
        "name": "112",
        "old_price": "69.0",
        "new_price": "46.9"
      },
      {
        "name": "282",
        "old_price": "169.0",
        "new_price": "117.4"
      },
      {
        "name": "579",
        "old_price": "319.0",
        "new_price": "229.6"
      },
      {
        "name": "1,230",
        "old_price": "779.0",
        "new_price": "454.1"
      },
      {
        "name": "1,845",
        "old_price": "1,079.0",
        "new_price": "678.6"
      },
      {
        "name": "3,134",
        "old_price": "1,800.0",
        "new_price": "1,132.2"
      },
      {
        "name": "6,279",
        "old_price": "3,700.0",
        "new_price": "2,238.5"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Tom&amp;Jerry CHASE",
    "image": "https://itemmania.s3.amazonaws.com/game/LlsrtShtoBvDKV3rQrXPQCh0UUgDg9l3uc3RICcb.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2328",
    "package": [
      {
        "name": "60",
        "old_price": "",
        "new_price": "38.0"
      },
      {
        "name": "180",
        "old_price": "",
        "new_price": "105.0"
      },
      {
        "name": "300",
        "old_price": "",
        "new_price": "170.0"
      },
      {
        "name": "1,200",
        "old_price": "720.0",
        "new_price": "705.6"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Pokemon UNITE",
    "image": "https://itemmania.s3.amazonaws.com/game/96BY3ABTiLaYwZ4DkKMmxHrSkOiMQyTh6R4g8eZs.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2210",
    "package": [
      {
        "name": "60",
        "old_price": "35.0",
        "new_price": "30.6"
      },
      {
        "name": "245+5",
        "old_price": "149.0",
        "new_price": "122.4"
      },
      {
        "name": "490+35",
        "old_price": "299.0",
        "new_price": "234.7"
      },
      {
        "name": "1,220+130",
        "old_price": "729.0",
        "new_price": "557.6"
      },
      {
        "name": "2,450+290",
        "old_price": "1,450.0",
        "new_price": "1,097.6"
      },
      {
        "name": "3,050+450",
        "old_price": "1,800.0",
        "new_price": "1,362.6"
      },
      {
        "name": "6,000+1,100",
        "old_price": "3,700.0",
        "new_price": "2,800.9"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Love and Deepspace",
    "image": "https://itemmania.s3.amazonaws.com/game/NLlTLrdtE13yA5Idlosehw33X56T4Oxf80tPgR7Q.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2330",
    "package": [
      {
        "name": "300",
        "old_price": "199.0",
        "new_price": "168.3"
      },
      {
        "name": "980",
        "old_price": "549.0",
        "new_price": "520.4"
      },
      {
        "name": "1,980",
        "old_price": "1,100.0",
        "new_price": "959.2"
      },
      {
        "name": "3,280",
        "old_price": "1,800.0",
        "new_price": "1,596.6"
      },
      {
        "name": "6,480",
        "old_price": "3,990.0",
        "new_price": "3,184.0"
      },
      {
        "name": "Companionship Pack",
        "old_price": "699.0",
        "new_price": "642.3"
      },
      {
        "name": "Aurum Pass (30 Days)",
        "old_price": "199.0",
        "new_price": "168.3"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกเซิร์ฟเวอร์3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "AFK Journey",
    "image": "https://itemmania.s3.amazonaws.com/game/WFdwuN61ninQzK3aX9PTPZ3mP8VgZDExUZvknoAp.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2332",
    "package": [
      {
        "name": "21",
        "old_price": "35.0",
        "new_price": "33.0"
      },
      {
        "name": "126",
        "old_price": "179.0",
        "new_price": "167.1"
      },
      {
        "name": "294",
        "old_price": "349.0",
        "new_price": "325.9"
      },
      {
        "name": "588",
        "old_price": "729.0",
        "new_price": "680.8"
      },
      {
        "name": "1,554",
        "old_price": "1,800.0",
        "new_price": "1,681.2"
      },
      {
        "name": "3,150",
        "old_price": "3,700.0",
        "new_price": "3,278.2"
      },
      {
        "name": "Growth Bundle",
        "old_price": "1,250.0",
        "new_price": "1,025.0"
      },
      {
        "name": "Esperia MonThly - Classic Gazette",
        "old_price": "179.0",
        "new_price": "167.0"
      },
      {
        "name": "Esperia MonThly - Premium Gazette",
        "old_price": "549.0",
        "new_price": "515.5"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Forsaken World 2",
    "image": "https://itemmania.s3.amazonaws.com/game/0VPd3oQuKufnDTFChnqI5i1rPh70utdZTWewGFOi.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2338",
    "package": [
      {
        "name": "10",
        "old_price": "",
        "new_price": "35.0"
      },
      {
        "name": "50",
        "old_price": "175.0",
        "new_price": "158.3"
      },
      {
        "name": "100",
        "old_price": "350.0",
        "new_price": "316.7"
      },
      {
        "name": "150",
        "old_price": "525.0",
        "new_price": "475.1"
      },
      {
        "name": "200",
        "old_price": "700.0",
        "new_price": "622.3"
      },
      {
        "name": "300",
        "old_price": "1,050.0",
        "new_price": "930.3"
      },
      {
        "name": "500",
        "old_price": "1,750.0",
        "new_price": "1,547.0"
      },
      {
        "name": "1,000",
        "old_price": "3,500.0",
        "new_price": "3,066.0"
      },
      {
        "name": "1,500",
        "old_price": "5,250.0",
        "new_price": "4,599.0"
      },
      {
        "name": "3,000",
        "old_price": "10,500.0",
        "new_price": "9,198.0"
      }
    ],
    "cont": "\n                Forsaken World 21. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Soul Land : New World",
    "image": "https://itemmania.s3.amazonaws.com/game/1kPAAXGnJbCe4hGVRY4ahQXIGUjiFCeRLWM7XdgV.jpeg",
    "link": "https://www.itemmania.in.th/gamecash/payment/2340",
    "package": [
      {
        "name": "6",
        "old_price": "210.0",
        "new_price": "195.0"
      },
      {
        "name": "19",
        "old_price": "689.0",
        "new_price": "587.0"
      },
      {
        "name": "32",
        "old_price": "1,170.0",
        "new_price": "968.7"
      },
      {
        "name": "50",
        "old_price": "1,800.0",
        "new_price": "1,537.2"
      },
      {
        "name": "100",
        "old_price": "3,700.0",
        "new_price": "3,078.4"
      },
      {
        "name": "200",
        "old_price": "6,990.0",
        "new_price": "6,172.1"
      },
      {
        "name": "300",
        "old_price": "10,900.0",
        "new_price": "9,275.9"
      },
      {
        "name": "500",
        "old_price": "17,000.0",
        "new_price": "15,470.0"
      }
    ],
    "cont": "\n                Soul Land : New World1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Lord Of Nazarick",
    "image": "https://itemmania.s3.amazonaws.com/game/NOhlLoKj6DHLqKE503DmPuG0SPlXjB6TwvD9NYKu.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2352",
    "package": [
      {
        "name": "60+6",
        "old_price": "",
        "new_price": "32.0"
      },
      {
        "name": "300+30",
        "old_price": "200.0",
        "new_price": "151.0"
      },
      {
        "name": "980+110",
        "old_price": "575.0",
        "new_price": "449.0"
      },
      {
        "name": "1,980+260",
        "old_price": "1,125.0",
        "new_price": "880.8"
      },
      {
        "name": "3,280+500",
        "old_price": "2,025.0",
        "new_price": "1,468.1"
      },
      {
        "name": "6,480+1,300",
        "old_price": "3,275.0",
        "new_price": "2,937.6"
      },
      {
        "name": "Outfit Ticket Pack",
        "old_price": "375.0",
        "new_price": "301.1"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. กรอกชื่อตัวละคร3. เลือกแพ็กเกจ4. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ5. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้6. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Heaven Burns Red",
    "image": "https://itemmania.s3.amazonaws.com/game/rgZ2YbwmZ5wpapXl480L3SE3pgKyXuViWZq0OTiu.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2350",
    "package": [
      {
        "name": "130",
        "old_price": "49.0",
        "new_price": "35.0"
      },
      {
        "name": "410",
        "old_price": "129.0",
        "new_price": "103.0"
      },
      {
        "name": "870",
        "old_price": "249.0",
        "new_price": "206.1"
      },
      {
        "name": "1,370",
        "old_price": "399.0",
        "new_price": "322.3"
      },
      {
        "name": "2,720",
        "old_price": "699.0",
        "new_price": "596.9"
      },
      {
        "name": "4,750",
        "old_price": "1,190.0",
        "new_price": "998.4"
      },
      {
        "name": "10,000",
        "old_price": "2,490.0",
        "new_price": "2,046.7"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "DD Tank Origin",
    "image": "https://itemmania.s3.amazonaws.com/game/ap90htigTn0jAc1FocO2mojs51lLUmXs8qOhPFaH.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2348",
    "package": [
      {
        "name": "1",
        "old_price": "30.0",
        "new_price": "28.5"
      },
      {
        "name": "2",
        "old_price": "60.0",
        "new_price": "57.0"
      },
      {
        "name": "3",
        "old_price": "90.0",
        "new_price": "85.5"
      },
      {
        "name": "6",
        "old_price": "180.0",
        "new_price": "171.0"
      },
      {
        "name": "12",
        "old_price": "360.0",
        "new_price": "342.0"
      },
      {
        "name": "22",
        "old_price": "650.0",
        "new_price": "617.5"
      },
      {
        "name": "30",
        "old_price": "900.0",
        "new_price": "855.0"
      },
      {
        "name": "60",
        "old_price": "1,800.0",
        "new_price": "1,710.0"
      },
      {
        "name": "90",
        "old_price": "2,600.0",
        "new_price": "2,470.0"
      },
      {
        "name": "100",
        "old_price": "3,000.0",
        "new_price": "2,850.0"
      },
      {
        "name": "500",
        "old_price": "13,000.0",
        "new_price": "12,350.0"
      },
      {
        "name": "1,000",
        "old_price": "26,000.0",
        "new_price": "24,700.0"
      }
    ],
    "cont": "\n                1. ตรวจสอบ UID และกรอกให้ถูกต้อง2. เลือกแพ็กเกจ3. หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ4. หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้5. หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้6. 12\n                                \n                                            \n                                    \n            "
  },
  {
    "name": "Magic Chess Go Go",
    "image": "https://itemmania.s3.amazonaws.com/game/HD6OUeRZCwHFqrBWTVGREYiYaBrnLaeUEFg8pIX3.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2360",
    "package": [
      {
        "name": "20+2",
        "old_price": "12.0",
        "new_price": "11.2"
      },
      {
        "name": "51+5",
        "old_price": "30.0",
        "new_price": "26.9"
      },
      {
        "name": "102+10",
        "old_price": "60.0",
        "new_price": "53.9"
      },
      {
        "name": "203+20",
        "old_price": "120.0",
        "new_price": "96.9"
      },
      {
        "name": "303+33",
        "old_price": "180.0",
        "new_price": "142.7"
      },
      {
        "name": "504+66",
        "old_price": "300.0",
        "new_price": "237.9"
      },
      {
        "name": "1,007+156",
        "old_price": "600.0",
        "new_price": "474.0"
      },
      {
        "name": "2,015+383",
        "old_price": "1,200.0",
        "new_price": "948.0"
      },
      {
        "name": "5,035+1,007",
        "old_price": "3,000.0",
        "new_price": "2,322.0"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "Mirren : Star Legends",
    "image": "https://itemmania.s3.amazonaws.com/game/xo42ynDmF9mGR3NCs52sMaA3AQQu73vBiJw98zti.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2374",
    "package": [
      {
        "name": "60",
        "old_price": "32.0",
        "new_price": "27.4"
      },
      {
        "name": "300",
        "old_price": "163.0",
        "new_price": "126.4"
      },
      {
        "name": "980",
        "old_price": "488.0",
        "new_price": "371.3"
      },
      {
        "name": "1,980",
        "old_price": "813.0",
        "new_price": "747.9"
      },
      {
        "name": "3,280",
        "old_price": "1,628.0",
        "new_price": "1,227.5"
      },
      {
        "name": "6,480",
        "old_price": "3,256.0",
        "new_price": "2,455.0"
      },
      {
        "name": "GrowthPack",
        "old_price": "325.0",
        "new_price": "250.9"
      },
      {
        "name": "Growth Selection 1",
        "old_price": "488.0",
        "new_price": "371.3"
      },
      {
        "name": "Growth Selection 2",
        "old_price": "488.0",
        "new_price": "371.3"
      },
      {
        "name": "Growth Selection 3",
        "old_price": "618.0",
        "new_price": "469.6"
      },
      {
        "name": "Growth Selection 4",
        "old_price": "813.0",
        "new_price": "616.2"
      },
      {
        "name": "Rune Pack",
        "old_price": "813.0",
        "new_price": "616.2"
      },
      {
        "name": "Summon Pack",
        "old_price": "1,628.0",
        "new_price": "1,227.5"
      },
      {
        "name": "Premium Summon Pack",
        "old_price": "3,256.0",
        "new_price": "2,455.0"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  },
  {
    "name": "HAIKYU!! FLY HIGH",
    "image": "https://itemmania.s3.amazonaws.com/game/8RlXAFJJk4srdXalimyx1zm7NVDuzoaOwNTMdMly.png",
    "link": "https://www.itemmania.in.th/gamecash/payment/2388",
    "package": [
      {
        "name": "60",
        "old_price": "39.0",
        "new_price": "29.0"
      },
      {
        "name": "300",
        "old_price": "175.0",
        "new_price": "139.1"
      },
      {
        "name": "980",
        "old_price": "529.0",
        "new_price": "419.4"
      },
      {
        "name": "1,980",
        "old_price": "1,050.0",
        "new_price": "859.9"
      },
      {
        "name": "3,280",
        "old_price": "1,830.0",
        "new_price": "1,379.8"
      },
      {
        "name": "6,480",
        "old_price": "3,590.0",
        "new_price": "2,749.9"
      }
    ],
    "cont": "\n                \n                                \n                                    \n            "
  }
]
;
global.mobile = [
  {
    name: "Promptpay QR",
    image: "https://www.itemmania.in.th/image/Mileage/img_qrcash.jpg",
    link: "https://www.itemmania.in.th/gamecash/payment/716",
    package: [
      {
        name: "เติมเงิน 20 บาท",
        old_price: "",
        new_price: "20.00",
      },
      {
        name: "เติมเงิน 50 บาท",
        old_price: "",
        new_price: "50.00",
      },
      {
        name: "เติมเงิน 100 บาท",
        old_price: "",
        new_price: "100.00",
      },
      {
        name: "เติมเงิน 150 บาท",
        old_price: "",
        new_price: "150.00",
      },
      {
        name: "เติมเงิน 200 บาท",
        old_price: "",
        new_price: "200.00",
      },
      {
        name: "เติมเงิน 500 บาท",
        old_price: "",
        new_price: "500.00",
      },
      {
        name: "เติมเงิน 1,000 บาท",
        old_price: "",
        new_price: "1,000.00",
      },
      {
        name: "เติมเงิน 5,000 บาท",
        old_price: "",
        new_price: "5,000.00",
      },
      {
        name: "เติมเงิน 10,000 บาท",
        old_price: "",
        new_price: "10,000.00",
      },
    ],
  },
  {
    name: "Mobile banking",
    image: "https://www.itemmania.in.th/image/Mileage/img_mobilebank.jpg",
    link: "https://www.itemmania.in.th/gamecash/payment/716",
    package: [
      {
        name: "เติมเงิน 20 บาท",
        old_price: "",
        new_price: "20.00",
      },
      {
        name: "เติมเงิน 50 บาท",
        old_price: "",
        new_price: "50.00",
      },
      {
        name: "เติมเงิน 100 บาท",
        old_price: "",
        new_price: "100.00",
      },
      {
        name: "เติมเงิน 150 บาท",
        old_price: "",
        new_price: "150.00",
      },
      {
        name: "เติมเงิน 200 บาท",
        old_price: "",
        new_price: "200.00",
      },
      {
        name: "เติมเงิน 500 บาท",
        old_price: "",
        new_price: "500.00",
      },
      {
        name: "เติมเงิน 1,000 บาท",
        old_price: "",
        new_price: "1,000.00",
      },
      {
        name: "เติมเงิน 5,000 บาท",
        old_price: "",
        new_price: "5,000.00",
      },
      {
        name: "เติมเงิน 10,000 บาท",
        old_price: "",
        new_price: "10,000.00",
      },
    ],
  },
  {
    name: "Line Pay",
    image: "https://www.itemmania.in.th/image/Mileage/img_linepay.jpg",
    link: "https://www.itemmania.in.th/gamecash/payment/716",
    package: [
      {
        name: "เติมเงิน 20 บาท",
        old_price: "",
        new_price: "20.00",
      },
      {
        name: "เติมเงิน 50 บาท",
        old_price: "",
        new_price: "50.00",
      },
      {
        name: "เติมเงิน 100 บาท",
        old_price: "",
        new_price: "100.00",
      },
      {
        name: "เติมเงิน 150 บาท",
        old_price: "",
        new_price: "150.00",
      },
      {
        name: "เติมเงิน 200 บาท",
        old_price: "",
        new_price: "200.00",
      },
      {
        name: "เติมเงิน 500 บาท",
        old_price: "",
        new_price: "500.00",
      },
      {
        name: "เติมเงิน 1,000 บาท",
        old_price: "",
        new_price: "1,000.00",
      },
      {
        name: "เติมเงิน 5,000 บาท",
        old_price: "",
        new_price: "5,000.00",
      },
      {
        name: "เติมเงิน 10,000 บาท",
        old_price: "",
        new_price: "10,000.00",
      },
    ],
  },
  {
    name: "True Money",
    image: "https://www.itemmania.in.th/image/Mileage/img_truemoney.jpg",
    link: "https://www.itemmania.in.th/gamecash/payment/716",
    package: [
      {
        name: "เติมเงิน 20 บาท",
        old_price: "",
        new_price: "20.00",
      },
      {
        name: "เติมเงิน 50 บาท",
        old_price: "",
        new_price: "50.00",
      },
      {
        name: "เติมเงิน 100 บาท",
        old_price: "",
        new_price: "100.00",
      },
      {
        name: "เติมเงิน 150 บาท",
        old_price: "",
        new_price: "150.00",
      },
      {
        name: "เติมเงิน 200 บาท",
        old_price: "",
        new_price: "200.00",
      },
      {
        name: "เติมเงิน 500 บาท",
        old_price: "",
        new_price: "500.00",
      },
      {
        name: "เติมเงิน 1,000 บาท",
        old_price: "",
        new_price: "1,000.00",
      },
      {
        name: "เติมเงิน 5,000 บาท",
        old_price: "",
        new_price: "5,000.00",
      },
      {
        name: "เติมเงิน 10,000 บาท",
        old_price: "",
        new_price: "10,000.00",
      },
    ],
  },
  {
    name: "ShopeePay",
    image: "https://www.itemmania.in.th/image/Mileage/img_shopee.jpg",
    link: "https://www.itemmania.in.th/gamecash/payment/716",
    package: [
      {
        name: "เติมเงิน 20 บาท",
        old_price: "",
        new_price: "20.00",
      },
      {
        name: "เติมเงิน 50 บาท",
        old_price: "",
        new_price: "50.00",
      },
      {
        name: "เติมเงิน 100 บาท",
        old_price: "",
        new_price: "100.00",
      },
      {
        name: "เติมเงิน 150 บาท",
        old_price: "",
        new_price: "150.00",
      },
      {
        name: "เติมเงิน 200 บาท",
        old_price: "",
        new_price: "200.00",
      },
      {
        name: "เติมเงิน 500 บาท",
        old_price: "",
        new_price: "500.00",
      },
      {
        name: "เติมเงิน 1,000 บาท",
        old_price: "",
        new_price: "1,000.00",
      },
      {
        name: "เติมเงิน 5,000 บาท",
        old_price: "",
        new_price: "5,000.00",
      },
      {
        name: "เติมเงิน 10,000 บาท",
        old_price: "",
        new_price: "10,000.00",
      },
    ],
  },
]